{
  "schemaVersion": 1,
  "id": "vilnius-wide-osm-traffic-signals",
  "description": "Separable OSM-derived vehicle traffic-signal nodes inside the checked-in Vilnius wide projected envelope.",
  "source": {
    "name": "OpenStreetMap",
    "url": "https://www.openstreetmap.org/copyright",
    "license": "ODbL 1.0",
    "overpassEndpoint": "https://overpass-api.de/api/interpreter",
    "overpassQuery": "[out:csv(::id,::lat,::lon,\"traffic_signals:direction\";true;\",\")][timeout:120];node[\"highway\"=\"traffic_signals\"](54.59491072850428,24.874560874515495,54.82186915240517,25.454831175399967);out body;",
    "osmBaseTimestamp": "2026-07-31T23:40:21Z",
    "fetchedAt": "2026-08-01",
    "notes": "Only highway=traffic_signals nodes are included. Coordinates were transformed from WGS84 to EPSG:3346 with GDAL 3.8.5 and clipped to data/regions/vilnius-wide.json. Signal direction is retained only where mapped."
  },
  "boundsLks94": {
    "minEasting": 556032,
    "minNorthing": 6051072,
    "maxEasting": 594176,
    "maxNorthing": 6077184
  },
  "signalCount": 480,
  "signals": [
    {
      "id": "osm:node:15389886",
      "osmNodeId": 15389886,
      "wgs84": {
        "latitude": 54.7309125,
        "longitude": 25.2397012
      },
      "lks94": {
        "easting": 579845.6,
        "northing": 6066767.053
      }
    },
    {
      "id": "osm:node:15390020",
      "osmNodeId": 15390020,
      "wgs84": {
        "latitude": 54.7336274,
        "longitude": 25.2534216
      },
      "lks94": {
        "easting": 580723.848,
        "northing": 6067084.887
      }
    },
    {
      "id": "osm:node:31294780",
      "osmNodeId": 31294780,
      "wgs84": {
        "latitude": 54.6920596,
        "longitude": 25.2800805
      },
      "lks94": {
        "easting": 582525.038,
        "northing": 6062489.937
      }
    },
    {
      "id": "osm:node:31294794",
      "osmNodeId": 31294794,
      "wgs84": {
        "latitude": 54.6895723,
        "longitude": 25.2884235
      },
      "lks94": {
        "easting": 583067.95,
        "northing": 6062222.974
      }
    },
    {
      "id": "osm:node:31295263",
      "osmNodeId": 31295263,
      "wgs84": {
        "latitude": 54.6848887,
        "longitude": 25.2892915
      },
      "lks94": {
        "easting": 583133.481,
        "northing": 6061702.782
      }
    },
    {
      "id": "osm:node:31295273",
      "osmNodeId": 31295273,
      "wgs84": {
        "latitude": 54.6859558,
        "longitude": 25.2861495
      },
      "lks94": {
        "easting": 582928.721,
        "northing": 6061817.82
      }
    },
    {
      "id": "osm:node:31295275",
      "osmNodeId": 31295275,
      "wgs84": {
        "latitude": 54.6882582,
        "longitude": 25.2880433
      },
      "lks94": {
        "easting": 583046.122,
        "northing": 6062076.283
      }
    },
    {
      "id": "osm:node:31435758",
      "osmNodeId": 31435758,
      "wgs84": {
        "latitude": 54.6659768,
        "longitude": 25.2728257
      },
      "lks94": {
        "easting": 582109.978,
        "northing": 6059578.776
      }
    },
    {
      "id": "osm:node:31435765",
      "osmNodeId": 31435765,
      "wgs84": {
        "latitude": 54.661445,
        "longitude": 25.273605
      },
      "lks94": {
        "easting": 582169.395,
        "northing": 6059075.362
      }
    },
    {
      "id": "osm:node:31435778",
      "osmNodeId": 31435778,
      "wgs84": {
        "latitude": 54.652228,
        "longitude": 25.2715184
      },
      "lks94": {
        "easting": 582053.351,
        "northing": 6058047.2
      }
    },
    {
      "id": "osm:node:31435787",
      "osmNodeId": 31435787,
      "wgs84": {
        "latitude": 54.6431083,
        "longitude": 25.2739676
      },
      "lks94": {
        "easting": 582229.802,
        "northing": 6057035.172
      }
    },
    {
      "id": "osm:node:31435810",
      "osmNodeId": 31435810,
      "wgs84": {
        "latitude": 54.6430287,
        "longitude": 25.2739794
      },
      "lks94": {
        "easting": 582230.724,
        "northing": 6057026.328
      }
    },
    {
      "id": "osm:node:31436016",
      "osmNodeId": 31436016,
      "wgs84": {
        "latitude": 54.6429934,
        "longitude": 25.2778053
      },
      "lks94": {
        "easting": 582477.73,
        "northing": 6057026.885
      }
    },
    {
      "id": "osm:node:31436043",
      "osmNodeId": 31436043,
      "wgs84": {
        "latitude": 54.6740438,
        "longitude": 25.2895749
      },
      "lks94": {
        "easting": 583173.922,
        "northing": 6060496.232
      }
    },
    {
      "id": "osm:node:31436065",
      "osmNodeId": 31436065,
      "wgs84": {
        "latitude": 54.6621603,
        "longitude": 25.3014641
      },
      "lks94": {
        "easting": 583965.209,
        "northing": 6059187.916
      }
    },
    {
      "id": "osm:node:31437124",
      "osmNodeId": 31437124,
      "wgs84": {
        "latitude": 54.6781546,
        "longitude": 25.2793687
      },
      "lks94": {
        "easting": 582507.351,
        "northing": 6060941.665
      }
    },
    {
      "id": "osm:node:31437126",
      "osmNodeId": 31437126,
      "wgs84": {
        "latitude": 54.6771028,
        "longitude": 25.2804877
      },
      "lks94": {
        "easting": 582581.647,
        "northing": 6060825.93
      }
    },
    {
      "id": "osm:node:31437132",
      "osmNodeId": 31437132,
      "wgs84": {
        "latitude": 54.6743542,
        "longitude": 25.2850562
      },
      "lks94": {
        "easting": 582881.862,
        "northing": 6060525.432
      }
    },
    {
      "id": "osm:node:31440055",
      "osmNodeId": 31440055,
      "wgs84": {
        "latitude": 54.6951164,
        "longitude": 25.2794318
      },
      "lks94": {
        "easting": 582477.019,
        "northing": 6062829.355
      }
    },
    {
      "id": "osm:node:31440057",
      "osmNodeId": 31440057,
      "wgs84": {
        "latitude": 54.6947944,
        "longitude": 25.2817211
      },
      "lks94": {
        "easting": 582625.242,
        "northing": 6062796.213
      }
    },
    {
      "id": "osm:node:31440061",
      "osmNodeId": 31440061,
      "wgs84": {
        "latitude": 54.6947418,
        "longitude": 25.2883063
      },
      "lks94": {
        "easting": 583049.836,
        "northing": 6062798.13
      }
    },
    {
      "id": "osm:node:31440103",
      "osmNodeId": 31440103,
      "wgs84": {
        "latitude": 54.6915859,
        "longitude": 25.2734293
      },
      "lks94": {
        "easting": 582097.224,
        "northing": 6062429.423
      }
    },
    {
      "id": "osm:node:31440106",
      "osmNodeId": 31440106,
      "wgs84": {
        "latitude": 54.691103,
        "longitude": 25.2765178
      },
      "lks94": {
        "easting": 582297.304,
        "northing": 6062379.299
      }
    },
    {
      "id": "osm:node:31440117",
      "osmNodeId": 31440117,
      "wgs84": {
        "latitude": 54.6904214,
        "longitude": 25.2599249
      },
      "lks94": {
        "easting": 581228.976,
        "northing": 6062284.121
      }
    },
    {
      "id": "osm:node:31448343",
      "osmNodeId": 31448343,
      "wgs84": {
        "latitude": 54.6726673,
        "longitude": 25.2755937
      },
      "lks94": {
        "easting": 582275.006,
        "northing": 6060326.575
      }
    },
    {
      "id": "osm:node:31448344",
      "osmNodeId": 31448344,
      "wgs84": {
        "latitude": 54.6727932,
        "longitude": 25.2779898
      },
      "lks94": {
        "easting": 582429.29,
        "northing": 6060343.396
      }
    },
    {
      "id": "osm:node:31448346",
      "osmNodeId": 31448346,
      "wgs84": {
        "latitude": 54.6719636,
        "longitude": 25.2825888
      },
      "lks94": {
        "easting": 582727.591,
        "northing": 6060256.482
      }
    },
    {
      "id": "osm:node:31451266",
      "osmNodeId": 31451266,
      "wgs84": {
        "latitude": 54.6197967,
        "longitude": 25.0661509
      },
      "lks94": {
        "easting": 568855.948,
        "northing": 6054217.44
      }
    },
    {
      "id": "osm:node:31451287",
      "osmNodeId": 31451287,
      "wgs84": {
        "latitude": 54.6326402,
        "longitude": 25.1516333
      },
      "lks94": {
        "easting": 574353.052,
        "northing": 6055733.878
      }
    },
    {
      "id": "osm:node:31452674",
      "osmNodeId": 31452674,
      "wgs84": {
        "latitude": 54.6922675,
        "longitude": 25.2717382
      },
      "lks94": {
        "easting": 581986.831,
        "northing": 6062503.299
      }
    },
    {
      "id": "osm:node:31452676",
      "osmNodeId": 31452676,
      "wgs84": {
        "latitude": 54.689003,
        "longitude": 25.2686414
      },
      "lks94": {
        "easting": 581793.762,
        "northing": 6062136.392
      }
    },
    {
      "id": "osm:node:31452680",
      "osmNodeId": 31452680,
      "wgs84": {
        "latitude": 54.6912287,
        "longitude": 25.2702716
      },
      "lks94": {
        "easting": 581894.379,
        "northing": 6062385.983
      }
    },
    {
      "id": "osm:node:31453226",
      "osmNodeId": 31453226,
      "wgs84": {
        "latitude": 54.690826,
        "longitude": 25.2798834
      },
      "lks94": {
        "easting": 582514.835,
        "northing": 6062352.423
      }
    },
    {
      "id": "osm:node:32070175",
      "osmNodeId": 32070175,
      "wgs84": {
        "latitude": 54.7369825,
        "longitude": 25.2658847
      },
      "lks94": {
        "easting": 581519.727,
        "northing": 6067472.676
      }
    },
    {
      "id": "osm:node:32070196",
      "osmNodeId": 32070196,
      "wgs84": {
        "latitude": 54.7305482,
        "longitude": 25.2453065
      },
      "lks94": {
        "easting": 580207.322,
        "northing": 6066732.904
      }
    },
    {
      "id": "osm:node:32083573",
      "osmNodeId": 32083573,
      "wgs84": {
        "latitude": 54.7292917,
        "longitude": 25.2367017
      },
      "lks94": {
        "easting": 579655.6,
        "northing": 6066583.269
      }
    },
    {
      "id": "osm:node:32083593",
      "osmNodeId": 32083593,
      "wgs84": {
        "latitude": 54.703181,
        "longitude": 25.2246248
      },
      "lks94": {
        "easting": 578928.477,
        "northing": 6063663.83
      }
    },
    {
      "id": "osm:node:32083636",
      "osmNodeId": 32083636,
      "wgs84": {
        "latitude": 54.7096586,
        "longitude": 25.2260147
      },
      "lks94": {
        "easting": 579005.461,
        "northing": 6064386.269
      }
    },
    {
      "id": "osm:node:32083649",
      "osmNodeId": 32083649,
      "wgs84": {
        "latitude": 54.7294464,
        "longitude": 25.2365416
      },
      "lks94": {
        "easting": 579644.986,
        "northing": 6066600.304
      }
    },
    {
      "id": "osm:node:32083710",
      "osmNodeId": 32083710,
      "wgs84": {
        "latitude": 54.6713366,
        "longitude": 25.2431982
      },
      "lks94": {
        "easting": 580188.248,
        "northing": 6060141.011
      }
    },
    {
      "id": "osm:node:32083712",
      "osmNodeId": 32083712,
      "wgs84": {
        "latitude": 54.675497,
        "longitude": 25.2512802
      },
      "lks94": {
        "easting": 580701.272,
        "northing": 6060613.267
      }
    },
    {
      "id": "osm:node:32083713",
      "osmNodeId": 32083713,
      "wgs84": {
        "latitude": 54.6773853,
        "longitude": 25.2549958
      },
      "lks94": {
        "easting": 580937.141,
        "northing": 6060827.685
      }
    },
    {
      "id": "osm:node:32083716",
      "osmNodeId": 32083716,
      "wgs84": {
        "latitude": 54.6770182,
        "longitude": 25.2488983
      },
      "lks94": {
        "easting": 580544.648,
        "northing": 6060779.821
      }
    },
    {
      "id": "osm:node:32083731",
      "osmNodeId": 32083731,
      "wgs84": {
        "latitude": 54.680815,
        "longitude": 25.2628885
      },
      "lks94": {
        "easting": 581439.264,
        "northing": 6061218.491
      }
    },
    {
      "id": "osm:node:32083732",
      "osmNodeId": 32083732,
      "wgs84": {
        "latitude": 54.6813425,
        "longitude": 25.2653722
      },
      "lks94": {
        "easting": 581598.362,
        "northing": 6061280.078
      }
    },
    {
      "id": "osm:node:32083736",
      "osmNodeId": 32083736,
      "wgs84": {
        "latitude": 54.6816996,
        "longitude": 25.2696075
      },
      "lks94": {
        "easting": 581870.745,
        "northing": 6061324.749
      }
    },
    {
      "id": "osm:node:32083738",
      "osmNodeId": 32083738,
      "wgs84": {
        "latitude": 54.6808762,
        "longitude": 25.2726479
      },
      "lks94": {
        "easting": 582068.456,
        "northing": 6061236.665
      }
    },
    {
      "id": "osm:node:32083743",
      "osmNodeId": 32083743,
      "wgs84": {
        "latitude": 54.6798954,
        "longitude": 25.2778456
      },
      "lks94": {
        "easting": 582405.605,
        "northing": 6061133.604
      }
    },
    {
      "id": "osm:node:32083794",
      "osmNodeId": 32083794,
      "wgs84": {
        "latitude": 54.6736375,
        "longitude": 25.2541205
      },
      "lks94": {
        "easting": 580888.143,
        "northing": 6060409.597
      }
    },
    {
      "id": "osm:node:32083799",
      "osmNodeId": 32083799,
      "wgs84": {
        "latitude": 54.6703397,
        "longitude": 25.2591151
      },
      "lks94": {
        "easting": 581216.849,
        "northing": 6060048.362
      }
    },
    {
      "id": "osm:node:32083852",
      "osmNodeId": 32083852,
      "wgs84": {
        "latitude": 54.6763739,
        "longitude": 25.2742978
      },
      "lks94": {
        "easting": 582183.94,
        "northing": 6060737.551
      }
    },
    {
      "id": "osm:node:32083855",
      "osmNodeId": 32083855,
      "wgs84": {
        "latitude": 54.6871334,
        "longitude": 25.271669
      },
      "lks94": {
        "easting": 581992.72,
        "northing": 6061931.863
      }
    },
    {
      "id": "osm:node:32083873",
      "osmNodeId": 32083873,
      "wgs84": {
        "latitude": 54.6826601,
        "longitude": 25.2733198
      },
      "lks94": {
        "easting": 582108.181,
        "northing": 6061435.974
      }
    },
    {
      "id": "osm:node:32124584",
      "osmNodeId": 32124584,
      "wgs84": {
        "latitude": 54.7391754,
        "longitude": 25.2738317
      },
      "lks94": {
        "easting": 582027.034,
        "northing": 6067725.98
      }
    },
    {
      "id": "osm:node:32137385",
      "osmNodeId": 32137385,
      "wgs84": {
        "latitude": 54.7290591,
        "longitude": 25.2678235
      },
      "lks94": {
        "easting": 581660.507,
        "northing": 6066593.157
      }
    },
    {
      "id": "osm:node:32137427",
      "osmNodeId": 32137427,
      "wgs84": {
        "latitude": 54.7043865,
        "longitude": 25.2664193
      },
      "lks94": {
        "easting": 581619.617,
        "northing": 6063845.784
      }
    },
    {
      "id": "osm:node:32144610",
      "osmNodeId": 32144610,
      "wgs84": {
        "latitude": 54.7110834,
        "longitude": 25.2571543
      },
      "lks94": {
        "easting": 581009.178,
        "northing": 6064580.328
      }
    },
    {
      "id": "osm:node:32155331",
      "osmNodeId": 32155331,
      "wgs84": {
        "latitude": 54.698301,
        "longitude": 25.2676978
      },
      "lks94": {
        "easting": 581714.242,
        "northing": 6063170.036
      }
    },
    {
      "id": "osm:node:32212857",
      "osmNodeId": 32212857,
      "wgs84": {
        "latitude": 54.6903262,
        "longitude": 25.2728836
      },
      "lks94": {
        "easting": 582064.587,
        "northing": 6062288.597
      }
    },
    {
      "id": "osm:node:32212861",
      "osmNodeId": 32212861,
      "wgs84": {
        "latitude": 54.6884066,
        "longitude": 25.2721509
      },
      "lks94": {
        "easting": 582021.222,
        "northing": 6062074.115
      }
    },
    {
      "id": "osm:node:32260111",
      "osmNodeId": 32260111,
      "wgs84": {
        "latitude": 54.7134484,
        "longitude": 25.2866476
      },
      "lks94": {
        "easting": 582904.753,
        "northing": 6064877.961
      }
    },
    {
      "id": "osm:node:32260125",
      "osmNodeId": 32260125,
      "wgs84": {
        "latitude": 54.7275313,
        "longitude": 25.2799492
      },
      "lks94": {
        "easting": 582444.582,
        "northing": 6066437.311
      }
    },
    {
      "id": "osm:node:32260134",
      "osmNodeId": 32260134,
      "wgs84": {
        "latitude": 54.7392579,
        "longitude": 25.2766621
      },
      "lks94": {
        "easting": 582209.118,
        "northing": 6067738.474
      }
    },
    {
      "id": "osm:node:32320162",
      "osmNodeId": 32320162,
      "wgs84": {
        "latitude": 54.7034559,
        "longitude": 25.288141
      },
      "lks94": {
        "easting": 583021.384,
        "northing": 6063767.695
      }
    },
    {
      "id": "osm:node:32320201",
      "osmNodeId": 32320201,
      "wgs84": {
        "latitude": 54.7039818,
        "longitude": 25.2799257
      },
      "lks94": {
        "easting": 582490.866,
        "northing": 6063816.535
      }
    },
    {
      "id": "osm:node:32323228",
      "osmNodeId": 32323228,
      "wgs84": {
        "latitude": 54.7040777,
        "longitude": 25.2888052
      },
      "lks94": {
        "easting": 583062.919,
        "northing": 6063837.679
      }
    },
    {
      "id": "osm:node:32323237",
      "osmNodeId": 32323237,
      "wgs84": {
        "latitude": 54.7075708,
        "longitude": 25.290712
      },
      "lks94": {
        "easting": 583178.656,
        "northing": 6064228.672
      }
    },
    {
      "id": "osm:node:32323242",
      "osmNodeId": 32323242,
      "wgs84": {
        "latitude": 54.7087099,
        "longitude": 25.2856327
      },
      "lks94": {
        "easting": 582849.022,
        "northing": 6064349.431
      }
    },
    {
      "id": "osm:node:32323257",
      "osmNodeId": 32323257,
      "wgs84": {
        "latitude": 54.7123476,
        "longitude": 25.2926535
      },
      "lks94": {
        "easting": 583293.976,
        "northing": 6064762.568
      }
    },
    {
      "id": "osm:node:32323258",
      "osmNodeId": 32323258,
      "wgs84": {
        "latitude": 54.7171905,
        "longitude": 25.2948777
      },
      "lks94": {
        "easting": 583427.343,
        "northing": 6065304.16
      }
    },
    {
      "id": "osm:node:32323294",
      "osmNodeId": 32323294,
      "wgs84": {
        "latitude": 54.7220117,
        "longitude": 25.2844452
      },
      "lks94": {
        "easting": 582745.407,
        "northing": 6065828.344
      }
    },
    {
      "id": "osm:node:32324355",
      "osmNodeId": 32324355,
      "wgs84": {
        "latitude": 54.7112953,
        "longitude": 25.3049706
      },
      "lks94": {
        "easting": 584089.778,
        "northing": 6064660.149
      }
    },
    {
      "id": "osm:node:32324664",
      "osmNodeId": 32324664,
      "wgs84": {
        "latitude": 54.7203151,
        "longitude": 25.3024642
      },
      "lks94": {
        "easting": 583909.65,
        "northing": 6065660.93
      }
    },
    {
      "id": "osm:node:32324781",
      "osmNodeId": 32324781,
      "wgs84": {
        "latitude": 54.710247,
        "longitude": 25.2491683
      },
      "lks94": {
        "easting": 580496.256,
        "northing": 6064478.059
      }
    },
    {
      "id": "osm:node:32324786",
      "osmNodeId": 32324786,
      "wgs84": {
        "latitude": 54.7089884,
        "longitude": 25.2403141
      },
      "lks94": {
        "easting": 579928.197,
        "northing": 6064327.874
      }
    },
    {
      "id": "osm:node:32324789",
      "osmNodeId": 32324789,
      "wgs84": {
        "latitude": 54.7087581,
        "longitude": 25.2403652
      },
      "lks94": {
        "easting": 579931.943,
        "northing": 6064302.303
      }
    },
    {
      "id": "osm:node:32326858",
      "osmNodeId": 32326858,
      "wgs84": {
        "latitude": 54.6876017,
        "longitude": 25.2678624
      },
      "lks94": {
        "easting": 581746.356,
        "northing": 6061979.539
      }
    },
    {
      "id": "osm:node:32327079",
      "osmNodeId": 32327079,
      "wgs84": {
        "latitude": 54.686025,
        "longitude": 25.2744734
      },
      "lks94": {
        "easting": 582175.768,
        "northing": 6061811.792
      }
    },
    {
      "id": "osm:node:32327081",
      "osmNodeId": 32327081,
      "wgs84": {
        "latitude": 54.6845375,
        "longitude": 25.2771756
      },
      "lks94": {
        "easting": 582353.003,
        "northing": 6061649.419
      }
    },
    {
      "id": "osm:node:32327082",
      "osmNodeId": 32327082,
      "wgs84": {
        "latitude": 54.6879101,
        "longitude": 25.2750555
      },
      "lks94": {
        "easting": 582209.488,
        "northing": 6062022.259
      }
    },
    {
      "id": "osm:node:32327230",
      "osmNodeId": 32327230,
      "wgs84": {
        "latitude": 54.6818712,
        "longitude": 25.2772715
      },
      "lks94": {
        "easting": 582364.584,
        "northing": 6061352.809
      }
    },
    {
      "id": "osm:node:32327925",
      "osmNodeId": 32327925,
      "wgs84": {
        "latitude": 54.6841928,
        "longitude": 25.2648415
      },
      "lks94": {
        "easting": 581558.427,
        "northing": 6061596.661
      }
    },
    {
      "id": "osm:node:32327937",
      "osmNodeId": 32327937,
      "wgs84": {
        "latitude": 54.6823855,
        "longitude": 25.2649774
      },
      "lks94": {
        "easting": 581570.813,
        "northing": 6061395.691
      }
    },
    {
      "id": "osm:node:32327992",
      "osmNodeId": 32327992,
      "wgs84": {
        "latitude": 54.6792265,
        "longitude": 25.2668428
      },
      "lks94": {
        "easting": 581697.439,
        "northing": 6061046.306
      }
    },
    {
      "id": "osm:node:32327998",
      "osmNodeId": 32327998,
      "wgs84": {
        "latitude": 54.6775319,
        "longitude": 25.2674412
      },
      "lks94": {
        "easting": 581739.431,
        "northing": 6060858.417
      }
    },
    {
      "id": "osm:node:32328002",
      "osmNodeId": 32328002,
      "wgs84": {
        "latitude": 54.6743972,
        "longitude": 25.2685646
      },
      "lks94": {
        "easting": 581818.18,
        "northing": 6060510.876
      }
    },
    {
      "id": "osm:node:32328008",
      "osmNodeId": 32328008,
      "wgs84": {
        "latitude": 54.6718817,
        "longitude": 25.2694319
      },
      "lks94": {
        "easting": 581879.176,
        "northing": 6060231.947
      }
    },
    {
      "id": "osm:node:32328013",
      "osmNodeId": 32328013,
      "wgs84": {
        "latitude": 54.6694062,
        "longitude": 25.2704235
      },
      "lks94": {
        "easting": 581948.116,
        "northing": 6059957.615
      }
    },
    {
      "id": "osm:node:32330074",
      "osmNodeId": 32330074,
      "wgs84": {
        "latitude": 54.7014744,
        "longitude": 25.262835
      },
      "lks94": {
        "easting": 581394.455,
        "northing": 6063517.544
      }
    },
    {
      "id": "osm:node:32334665",
      "osmNodeId": 32334665,
      "wgs84": {
        "latitude": 54.6950772,
        "longitude": 25.2643425
      },
      "lks94": {
        "easting": 581504.437,
        "northing": 6062807.369
      }
    },
    {
      "id": "osm:node:32336843",
      "osmNodeId": 32336843,
      "wgs84": {
        "latitude": 54.6702119,
        "longitude": 25.260211
      },
      "lks94": {
        "easting": 581287.789,
        "northing": 6060035.408
      }
    },
    {
      "id": "osm:node:32336845",
      "osmNodeId": 32336845,
      "wgs84": {
        "latitude": 54.671297,
        "longitude": 25.2663829
      },
      "lks94": {
        "easting": 581683.698,
        "northing": 6060163.327
      }
    },
    {
      "id": "osm:node:32336846",
      "osmNodeId": 32336846,
      "wgs84": {
        "latitude": 54.6724491,
        "longitude": 25.2727795
      },
      "lks94": {
        "easting": 582093.942,
        "northing": 6060298.999
      }
    },
    {
      "id": "osm:node:32336966",
      "osmNodeId": 32336966,
      "wgs84": {
        "latitude": 54.6670985,
        "longitude": 25.2536783
      },
      "lks94": {
        "easting": 580872.616,
        "northing": 6059681.387
      }
    },
    {
      "id": "osm:node:32336967",
      "osmNodeId": 32336967,
      "wgs84": {
        "latitude": 54.6665366,
        "longitude": 25.252097
      },
      "lks94": {
        "easting": 580771.73,
        "northing": 6059617.035
      }
    },
    {
      "id": "osm:node:32337904",
      "osmNodeId": 32337904,
      "wgs84": {
        "latitude": 54.6754786,
        "longitude": 25.2717335
      },
      "lks94": {
        "easting": 582020.373,
        "northing": 6060634.918
      }
    },
    {
      "id": "osm:node:32337907",
      "osmNodeId": 32337907,
      "wgs84": {
        "latitude": 54.6699991,
        "longitude": 25.273654
      },
      "lks94": {
        "easting": 582155.29,
        "northing": 6060027.371
      }
    },
    {
      "id": "osm:node:32339618",
      "osmNodeId": 32339618,
      "wgs84": {
        "latitude": 54.729107,
        "longitude": 25.2681696
      },
      "lks94": {
        "easting": 581682.702,
        "northing": 6066598.89
      }
    },
    {
      "id": "osm:node:32339648",
      "osmNodeId": 32339648,
      "wgs84": {
        "latitude": 54.7529636,
        "longitude": 25.2711987
      },
      "lks94": {
        "easting": 581829.689,
        "northing": 6069257.359
      }
    },
    {
      "id": "osm:node:32595651",
      "osmNodeId": 32595651,
      "wgs84": {
        "latitude": 54.7302722,
        "longitude": 25.2357032
      },
      "lks94": {
        "easting": 579589.369,
        "northing": 6066691.254
      }
    },
    {
      "id": "osm:node:32595841",
      "osmNodeId": 32595841,
      "wgs84": {
        "latitude": 54.7375487,
        "longitude": 25.2322769
      },
      "lks94": {
        "easting": 579354.476,
        "northing": 6067497.159
      }
    },
    {
      "id": "osm:node:32596691",
      "osmNodeId": 32596691,
      "wgs84": {
        "latitude": 54.7135372,
        "longitude": 25.2376059
      },
      "lks94": {
        "easting": 579744.758,
        "northing": 6064831.017
      }
    },
    {
      "id": "osm:node:32596701",
      "osmNodeId": 32596701,
      "wgs84": {
        "latitude": 54.7123434,
        "longitude": 25.2388274
      },
      "lks94": {
        "easting": 579825.806,
        "northing": 6064699.551
      }
    },
    {
      "id": "osm:node:32598459",
      "osmNodeId": 32598459,
      "wgs84": {
        "latitude": 54.7169563,
        "longitude": 25.221279
      },
      "lks94": {
        "easting": 578686.171,
        "northing": 6065193.092
      }
    },
    {
      "id": "osm:node:32598739",
      "osmNodeId": 32598739,
      "wgs84": {
        "latitude": 54.7292393,
        "longitude": 25.2184558
      },
      "lks94": {
        "easting": 578480.548,
        "northing": 6066556.879
      }
    },
    {
      "id": "osm:node:32600379",
      "osmNodeId": 32600379,
      "wgs84": {
        "latitude": 54.6948718,
        "longitude": 25.2505451
      },
      "lks94": {
        "easting": 580615.457,
        "northing": 6062768.579
      }
    },
    {
      "id": "osm:node:32600448",
      "osmNodeId": 32600448,
      "wgs84": {
        "latitude": 54.6953644,
        "longitude": 25.2559364
      },
      "lks94": {
        "easting": 580962.004,
        "northing": 6062829.604
      },
      "direction": "both"
    },
    {
      "id": "osm:node:32600451",
      "osmNodeId": 32600451,
      "wgs84": {
        "latitude": 54.6987111,
        "longitude": 25.2586542
      },
      "lks94": {
        "easting": 581130.515,
        "northing": 6063205.185
      }
    },
    {
      "id": "osm:node:32603147",
      "osmNodeId": 32603147,
      "wgs84": {
        "latitude": 54.7050025,
        "longitude": 25.3106169
      },
      "lks94": {
        "easting": 584466.671,
        "northing": 6063966.626
      }
    },
    {
      "id": "osm:node:32603235",
      "osmNodeId": 32603235,
      "wgs84": {
        "latitude": 54.7057044,
        "longitude": 25.3045035
      },
      "lks94": {
        "easting": 584071.245,
        "northing": 6064037.398
      }
    },
    {
      "id": "osm:node:32867686",
      "osmNodeId": 32867686,
      "wgs84": {
        "latitude": 54.6942303,
        "longitude": 25.2159131
      },
      "lks94": {
        "easting": 578384.28,
        "northing": 6062657.969
      }
    },
    {
      "id": "osm:node:32867694",
      "osmNodeId": 32867694,
      "wgs84": {
        "latitude": 54.6881292,
        "longitude": 25.2077985
      },
      "lks94": {
        "easting": 577872.877,
        "northing": 6061969.963
      }
    },
    {
      "id": "osm:node:32868721",
      "osmNodeId": 32868721,
      "wgs84": {
        "latitude": 54.6739965,
        "longitude": 25.2015098
      },
      "lks94": {
        "easting": 577494.348,
        "northing": 6060390.216
      }
    },
    {
      "id": "osm:node:32868847",
      "osmNodeId": 32868847,
      "wgs84": {
        "latitude": 54.678039,
        "longitude": 25.2022002
      },
      "lks94": {
        "easting": 577531.172,
        "northing": 6060840.857
      }
    },
    {
      "id": "osm:node:32869028",
      "osmNodeId": 32869028,
      "wgs84": {
        "latitude": 54.6700917,
        "longitude": 25.1981245
      },
      "lks94": {
        "easting": 577283.43,
        "northing": 6059951.932
      }
    },
    {
      "id": "osm:node:32871408",
      "osmNodeId": 32871408,
      "wgs84": {
        "latitude": 54.6988684,
        "longitude": 25.2588209
      },
      "lks94": {
        "easting": 581140.946,
        "northing": 6063222.883
      }
    },
    {
      "id": "osm:node:33140644",
      "osmNodeId": 33140644,
      "wgs84": {
        "latitude": 54.6461066,
        "longitude": 25.2653951
      },
      "lks94": {
        "easting": 581670.498,
        "northing": 6057358.839
      }
    },
    {
      "id": "osm:node:33140935",
      "osmNodeId": 33140935,
      "wgs84": {
        "latitude": 54.637584,
        "longitude": 25.2669199
      },
      "lks94": {
        "easting": 581786.012,
        "northing": 6056412.17
      }
    },
    {
      "id": "osm:node:33256276",
      "osmNodeId": 33256276,
      "wgs84": {
        "latitude": 54.6904076,
        "longitude": 25.2564747
      },
      "lks94": {
        "easting": 581006.576,
        "northing": 6062278.598
      }
    },
    {
      "id": "osm:node:33351971",
      "osmNodeId": 33351971,
      "wgs84": {
        "latitude": 54.6721612,
        "longitude": 25.2903459
      },
      "lks94": {
        "easting": 583227.496,
        "northing": 6060287.638
      }
    },
    {
      "id": "osm:node:33351987",
      "osmNodeId": 33351987,
      "wgs84": {
        "latitude": 54.6737625,
        "longitude": 25.2982919
      },
      "lks94": {
        "easting": 583736.69,
        "northing": 6060475.287
      }
    },
    {
      "id": "osm:node:33353013",
      "osmNodeId": 33353013,
      "wgs84": {
        "latitude": 54.6861776,
        "longitude": 25.3241126
      },
      "lks94": {
        "easting": 585375.909,
        "northing": 6061888.006
      }
    },
    {
      "id": "osm:node:33354739",
      "osmNodeId": 33354739,
      "wgs84": {
        "latitude": 54.7269265,
        "longitude": 25.3261399
      },
      "lks94": {
        "easting": 585420.933,
        "northing": 6066425.254
      }
    },
    {
      "id": "osm:node:33691163",
      "osmNodeId": 33691163,
      "wgs84": {
        "latitude": 54.6780118,
        "longitude": 25.2707808
      },
      "lks94": {
        "easting": 581953.829,
        "northing": 6060915.716
      }
    },
    {
      "id": "osm:node:33692214",
      "osmNodeId": 33692214,
      "wgs84": {
        "latitude": 54.8054379,
        "longitude": 25.273541
      },
      "lks94": {
        "easting": 581874.401,
        "northing": 6075099.854
      }
    },
    {
      "id": "osm:node:33732283",
      "osmNodeId": 33732283,
      "wgs84": {
        "latitude": 54.7166049,
        "longitude": 25.2248156
      },
      "lks94": {
        "easting": 578914.702,
        "northing": 6065157.957
      }
    },
    {
      "id": "osm:node:33732285",
      "osmNodeId": 33732285,
      "wgs84": {
        "latitude": 54.7164881,
        "longitude": 25.2282898
      },
      "lks94": {
        "easting": 579138.761,
        "northing": 6065148.87
      }
    },
    {
      "id": "osm:node:33732301",
      "osmNodeId": 33732301,
      "wgs84": {
        "latitude": 54.7211373,
        "longitude": 25.2228709
      },
      "lks94": {
        "easting": 578780.623,
        "northing": 6065660.172
      }
    },
    {
      "id": "osm:node:33732302",
      "osmNodeId": 33732302,
      "wgs84": {
        "latitude": 54.721157,
        "longitude": 25.2226142
      },
      "lks94": {
        "easting": 578764.048,
        "northing": 6065662.076
      }
    },
    {
      "id": "osm:node:33732314",
      "osmNodeId": 33732314,
      "wgs84": {
        "latitude": 54.7187929,
        "longitude": 25.214186
      },
      "lks94": {
        "easting": 578225.66,
        "northing": 6065389.554
      }
    },
    {
      "id": "osm:node:33732323",
      "osmNodeId": 33732323,
      "wgs84": {
        "latitude": 54.7117878,
        "longitude": 25.2144875
      },
      "lks94": {
        "easting": 578258.575,
        "northing": 6064610.308
      }
    },
    {
      "id": "osm:node:33732336",
      "osmNodeId": 33732336,
      "wgs84": {
        "latitude": 54.7112542,
        "longitude": 25.2170528
      },
      "lks94": {
        "easting": 578424.898,
        "northing": 6064553.789
      }
    },
    {
      "id": "osm:node:33734248",
      "osmNodeId": 33734248,
      "wgs84": {
        "latitude": 54.7157239,
        "longitude": 25.2513386
      },
      "lks94": {
        "easting": 580625.235,
        "northing": 6065090.059
      }
    },
    {
      "id": "osm:node:33736225",
      "osmNodeId": 33736225,
      "wgs84": {
        "latitude": 54.6900008,
        "longitude": 25.2518359
      },
      "lks94": {
        "easting": 580708.33,
        "northing": 6062227.984
      }
    },
    {
      "id": "osm:node:33765196",
      "osmNodeId": 33765196,
      "wgs84": {
        "latitude": 54.6769709,
        "longitude": 25.3071605
      },
      "lks94": {
        "easting": 584302.014,
        "northing": 6060842.948
      }
    },
    {
      "id": "osm:node:34103794",
      "osmNodeId": 34103794,
      "wgs84": {
        "latitude": 54.6666419,
        "longitude": 25.3053419
      },
      "lks94": {
        "easting": 584206.104,
        "northing": 6059691.297
      }
    },
    {
      "id": "osm:node:34490377",
      "osmNodeId": 34490377,
      "wgs84": {
        "latitude": 54.6907518,
        "longitude": 25.2779906
      },
      "lks94": {
        "easting": 582392.962,
        "northing": 6062341.942
      }
    },
    {
      "id": "osm:node:34490412",
      "osmNodeId": 34490412,
      "wgs84": {
        "latitude": 54.6901832,
        "longitude": 25.2793173
      },
      "lks94": {
        "easting": 582479.644,
        "northing": 6062280.223
      }
    },
    {
      "id": "osm:node:34823027",
      "osmNodeId": 34823027,
      "wgs84": {
        "latitude": 54.6996741,
        "longitude": 25.2685778
      },
      "lks94": {
        "easting": 581768.201,
        "northing": 6063323.868
      }
    },
    {
      "id": "osm:node:34823031",
      "osmNodeId": 34823031,
      "wgs84": {
        "latitude": 54.7047203,
        "longitude": 25.2707798
      },
      "lks94": {
        "easting": 581899.959,
        "northing": 6063888.01
      }
    },
    {
      "id": "osm:node:34823040",
      "osmNodeId": 34823040,
      "wgs84": {
        "latitude": 54.6962031,
        "longitude": 25.275214
      },
      "lks94": {
        "easting": 582202.942,
        "northing": 6062945.343
      }
    },
    {
      "id": "osm:node:34823041",
      "osmNodeId": 34823041,
      "wgs84": {
        "latitude": 54.6972803,
        "longitude": 25.2765395
      },
      "lks94": {
        "easting": 582286.201,
        "northing": 6063066.774
      }
    },
    {
      "id": "osm:node:34823218",
      "osmNodeId": 34823218,
      "wgs84": {
        "latitude": 54.7211319,
        "longitude": 25.2443462
      },
      "lks94": {
        "easting": 580164.058,
        "northing": 6065683.89
      }
    },
    {
      "id": "osm:node:34825447",
      "osmNodeId": 34825447,
      "wgs84": {
        "latitude": 54.6783589,
        "longitude": 25.2735702
      },
      "lks94": {
        "easting": 582133.01,
        "northing": 6060957.603
      }
    },
    {
      "id": "osm:node:36138654",
      "osmNodeId": 36138654,
      "wgs84": {
        "latitude": 54.7548752,
        "longitude": 25.2805352
      },
      "lks94": {
        "easting": 582426.782,
        "northing": 6069481.027
      }
    },
    {
      "id": "osm:node:36141432",
      "osmNodeId": 36141432,
      "wgs84": {
        "latitude": 54.7117371,
        "longitude": 25.3148945
      },
      "lks94": {
        "easting": 584728.297,
        "northing": 6064721.25
      }
    },
    {
      "id": "osm:node:36431761",
      "osmNodeId": 36431761,
      "wgs84": {
        "latitude": 54.734623,
        "longitude": 25.2516727
      },
      "lks94": {
        "easting": 580609.243,
        "northing": 6067193.674
      }
    },
    {
      "id": "osm:node:36432520",
      "osmNodeId": 36432520,
      "wgs84": {
        "latitude": 54.7230441,
        "longitude": 25.2826215
      },
      "lks94": {
        "easting": 582625.829,
        "northing": 6065941.088
      }
    },
    {
      "id": "osm:node:36742740",
      "osmNodeId": 36742740,
      "wgs84": {
        "latitude": 54.6731779,
        "longitude": 25.2403204
      },
      "lks94": {
        "easting": 579999.016,
        "northing": 6060342.641
      }
    },
    {
      "id": "osm:node:37442913",
      "osmNodeId": 37442913,
      "wgs84": {
        "latitude": 54.7113183,
        "longitude": 25.2986295
      },
      "lks94": {
        "easting": 583681.146,
        "northing": 6064655.129
      }
    },
    {
      "id": "osm:node:38458425",
      "osmNodeId": 38458425,
      "wgs84": {
        "latitude": 54.7237176,
        "longitude": 25.321258
      },
      "lks94": {
        "easting": 585113.217,
        "northing": 6066062.215
      }
    },
    {
      "id": "osm:node:39645797",
      "osmNodeId": 39645797,
      "wgs84": {
        "latitude": 54.7352728,
        "longitude": 25.2589229
      },
      "lks94": {
        "easting": 581074.843,
        "northing": 6067274.342
      }
    },
    {
      "id": "osm:node:40459755",
      "osmNodeId": 40459755,
      "wgs84": {
        "latitude": 54.7368614,
        "longitude": 25.2659079
      },
      "lks94": {
        "easting": 581521.464,
        "northing": 6067459.226
      }
    },
    {
      "id": "osm:node:41884410",
      "osmNodeId": 41884410,
      "wgs84": {
        "latitude": 54.7306292,
        "longitude": 25.2452909
      },
      "lks94": {
        "easting": 580206.158,
        "northing": 6066741.901
      }
    },
    {
      "id": "osm:node:43077948",
      "osmNodeId": 43077948,
      "wgs84": {
        "latitude": 54.7275567,
        "longitude": 25.2801972
      },
      "lks94": {
        "easting": 582460.503,
        "northing": 6066440.429
      }
    },
    {
      "id": "osm:node:43080061",
      "osmNodeId": 43080061,
      "wgs84": {
        "latitude": 54.7392578,
        "longitude": 25.2768835
      },
      "lks94": {
        "easting": 582223.374,
        "northing": 6067738.723
      }
    },
    {
      "id": "osm:node:43474292",
      "osmNodeId": 43474292,
      "wgs84": {
        "latitude": 54.7162211,
        "longitude": 25.257777
      },
      "lks94": {
        "easting": 581039.055,
        "northing": 6065152.806
      }
    },
    {
      "id": "osm:node:44584759",
      "osmNodeId": 44584759,
      "wgs84": {
        "latitude": 54.7227677,
        "longitude": 25.2431566
      },
      "lks94": {
        "easting": 580084.2,
        "northing": 6065864.576
      }
    },
    {
      "id": "osm:node:44586481",
      "osmNodeId": 44586481,
      "wgs84": {
        "latitude": 54.7211025,
        "longitude": 25.2441107
      },
      "lks94": {
        "easting": 580148.945,
        "northing": 6065680.35
      }
    },
    {
      "id": "osm:node:48802805",
      "osmNodeId": 48802805,
      "wgs84": {
        "latitude": 54.729255,
        "longitude": 25.2187156
      },
      "lks94": {
        "easting": 578497.25,
        "northing": 6066558.916
      }
    },
    {
      "id": "osm:node:48802807",
      "osmNodeId": 48802807,
      "wgs84": {
        "latitude": 54.729141,
        "longitude": 25.2186652
      },
      "lks94": {
        "easting": 578494.225,
        "northing": 6066546.173
      }
    },
    {
      "id": "osm:node:48802835",
      "osmNodeId": 48802835,
      "wgs84": {
        "latitude": 54.7169152,
        "longitude": 25.221503
      },
      "lks94": {
        "easting": 578700.682,
        "northing": 6065188.769
      }
    },
    {
      "id": "osm:node:48802844",
      "osmNodeId": 48802844,
      "wgs84": {
        "latitude": 54.7112009,
        "longitude": 25.2172675
      },
      "lks94": {
        "easting": 578438.835,
        "northing": 6064548.097
      }
    },
    {
      "id": "osm:node:49096534",
      "osmNodeId": 49096534,
      "wgs84": {
        "latitude": 54.6995804,
        "longitude": 25.2226938
      },
      "lks94": {
        "easting": 578811.008,
        "northing": 6063260.959
      }
    },
    {
      "id": "osm:node:49646893",
      "osmNodeId": 49646893,
      "wgs84": {
        "latitude": 54.7102418,
        "longitude": 25.2490225
      },
      "lks94": {
        "easting": 580486.871,
        "northing": 6064477.313
      }
    },
    {
      "id": "osm:node:50122460",
      "osmNodeId": 50122460,
      "wgs84": {
        "latitude": 54.6921693,
        "longitude": 25.4079748
      },
      "lks94": {
        "easting": 590769.439,
        "northing": 6062660
      }
    },
    {
      "id": "osm:node:50125041",
      "osmNodeId": 50125041,
      "wgs84": {
        "latitude": 54.723932,
        "longitude": 25.3383809
      },
      "lks94": {
        "easting": 586215.724,
        "northing": 6066106.978
      }
    },
    {
      "id": "osm:node:51415157",
      "osmNodeId": 51415157,
      "wgs84": {
        "latitude": 54.6929839,
        "longitude": 25.4105353
      },
      "lks94": {
        "easting": 590932.676,
        "northing": 6062753.966
      }
    },
    {
      "id": "osm:node:53407029",
      "osmNodeId": 53407029,
      "wgs84": {
        "latitude": 54.7072147,
        "longitude": 25.1866101
      },
      "lks94": {
        "easting": 576470.915,
        "northing": 6064070.651
      }
    },
    {
      "id": "osm:node:53407041",
      "osmNodeId": 53407041,
      "wgs84": {
        "latitude": 54.707273,
        "longitude": 25.1819602
      },
      "lks94": {
        "easting": 576171.157,
        "northing": 6064072.083
      }
    },
    {
      "id": "osm:node:53407053",
      "osmNodeId": 53407053,
      "wgs84": {
        "latitude": 54.7072946,
        "longitude": 25.179605
      },
      "lks94": {
        "easting": 576019.344,
        "northing": 6064071.933
      }
    },
    {
      "id": "osm:node:53407070",
      "osmNodeId": 53407070,
      "wgs84": {
        "latitude": 54.7102598,
        "longitude": 25.1750715
      },
      "lks94": {
        "easting": 575721.672,
        "northing": 6064397.024
      }
    },
    {
      "id": "osm:node:53819991",
      "osmNodeId": 53819991,
      "wgs84": {
        "latitude": 54.7104551,
        "longitude": 25.164825
      },
      "lks94": {
        "easting": 575061.057,
        "northing": 6064407.753
      }
    },
    {
      "id": "osm:node:55333627",
      "osmNodeId": 55333627,
      "wgs84": {
        "latitude": 54.690585,
        "longitude": 25.2784207
      },
      "lks94": {
        "easting": 582421.027,
        "northing": 6062323.885
      }
    },
    {
      "id": "osm:node:55343869",
      "osmNodeId": 55343869,
      "wgs84": {
        "latitude": 54.6750093,
        "longitude": 25.2747947
      },
      "lks94": {
        "easting": 582218.742,
        "northing": 6060586.272
      }
    },
    {
      "id": "osm:node:55369257",
      "osmNodeId": 55369257,
      "wgs84": {
        "latitude": 54.646898,
        "longitude": 25.211033
      },
      "lks94": {
        "easting": 578160.544,
        "northing": 6057385.063
      }
    },
    {
      "id": "osm:node:55923498",
      "osmNodeId": 55923498,
      "wgs84": {
        "latitude": 54.7109615,
        "longitude": 25.2575309
      },
      "lks94": {
        "easting": 581033.687,
        "northing": 6064567.197
      }
    },
    {
      "id": "osm:node:55934500",
      "osmNodeId": 55934500,
      "wgs84": {
        "latitude": 54.7111501,
        "longitude": 25.2573455
      },
      "lks94": {
        "easting": 581021.365,
        "northing": 6064587.971
      }
    },
    {
      "id": "osm:node:59968254",
      "osmNodeId": 59968254,
      "wgs84": {
        "latitude": 54.6851652,
        "longitude": 25.30858
      },
      "lks94": {
        "easting": 584376.559,
        "northing": 6061756.563
      }
    },
    {
      "id": "osm:node:59971375",
      "osmNodeId": 59971375,
      "wgs84": {
        "latitude": 54.6755226,
        "longitude": 25.2832147
      },
      "lks94": {
        "easting": 582760.722,
        "northing": 6060653.286
      }
    },
    {
      "id": "osm:node:59971387",
      "osmNodeId": 59971387,
      "wgs84": {
        "latitude": 54.6771348,
        "longitude": 25.280456
      },
      "lks94": {
        "easting": 582579.538,
        "northing": 6060829.454
      }
    },
    {
      "id": "osm:node:60463804",
      "osmNodeId": 60463804,
      "wgs84": {
        "latitude": 54.7084291,
        "longitude": 25.2908429
      },
      "lks94": {
        "easting": 583185.335,
        "northing": 6064324.344
      }
    },
    {
      "id": "osm:node:60463939",
      "osmNodeId": 60463939,
      "wgs84": {
        "latitude": 54.6848628,
        "longitude": 25.3092143
      },
      "lks94": {
        "easting": 584418.083,
        "northing": 6061723.672
      }
    },
    {
      "id": "osm:node:79672835",
      "osmNodeId": 79672835,
      "wgs84": {
        "latitude": 54.6883715,
        "longitude": 25.411325
      },
      "lks94": {
        "easting": 590993.902,
        "northing": 6062241.701
      }
    },
    {
      "id": "osm:node:79675029",
      "osmNodeId": 79675029,
      "wgs84": {
        "latitude": 54.6950597,
        "longitude": 25.3968023
      },
      "lks94": {
        "easting": 590042.816,
        "northing": 6062967.269
      }
    },
    {
      "id": "osm:node:87885180",
      "osmNodeId": 87885180,
      "wgs84": {
        "latitude": 54.7136509,
        "longitude": 25.2377845
      },
      "lks94": {
        "easting": 579756.042,
        "northing": 6064843.874
      }
    },
    {
      "id": "osm:node:87885189",
      "osmNodeId": 87885189,
      "wgs84": {
        "latitude": 54.712397,
        "longitude": 25.239172
      },
      "lks94": {
        "easting": 579847.904,
        "northing": 6064705.908
      }
    },
    {
      "id": "osm:node:130128664",
      "osmNodeId": 130128664,
      "wgs84": {
        "latitude": 54.6906854,
        "longitude": 25.2698411
      },
      "lks94": {
        "easting": 581867.72,
        "northing": 6062325.019
      }
    },
    {
      "id": "osm:node:135504070",
      "osmNodeId": 135504070,
      "wgs84": {
        "latitude": 54.7042969,
        "longitude": 25.2761075
      },
      "lks94": {
        "easting": 582244.16,
        "northing": 6063847.121
      }
    },
    {
      "id": "osm:node:137638086",
      "osmNodeId": 137638086,
      "wgs84": {
        "latitude": 54.6631146,
        "longitude": 25.2734291
      },
      "lks94": {
        "easting": 582154.677,
        "northing": 6059260.959
      }
    },
    {
      "id": "osm:node:137660658",
      "osmNodeId": 137660658,
      "wgs84": {
        "latitude": 54.6624838,
        "longitude": 25.3008998
      },
      "lks94": {
        "easting": 583928.137,
        "northing": 6059223.243
      }
    },
    {
      "id": "osm:node:196326033",
      "osmNodeId": 196326033,
      "wgs84": {
        "latitude": 54.7532716,
        "longitude": 25.2694677
      },
      "lks94": {
        "easting": 581717.647,
        "northing": 6069289.618
      }
    },
    {
      "id": "osm:node:196326844",
      "osmNodeId": 196326844,
      "wgs84": {
        "latitude": 54.753323,
        "longitude": 25.2691202
      },
      "lks94": {
        "easting": 581695.175,
        "northing": 6069294.933
      }
    },
    {
      "id": "osm:node:243848145",
      "osmNodeId": 243848145,
      "wgs84": {
        "latitude": 54.7101103,
        "longitude": 25.2860835
      },
      "lks94": {
        "easting": 582875.215,
        "northing": 6064505.809
      }
    },
    {
      "id": "osm:node:249070390",
      "osmNodeId": 249070390,
      "wgs84": {
        "latitude": 54.7188452,
        "longitude": 25.3171281
      },
      "lks94": {
        "easting": 584857.369,
        "northing": 6065514.982
      }
    },
    {
      "id": "osm:node:249514208",
      "osmNodeId": 249514208,
      "wgs84": {
        "latitude": 54.8106838,
        "longitude": 25.4160863
      },
      "lks94": {
        "easting": 591026.077,
        "northing": 6075859.447
      }
    },
    {
      "id": "osm:node:249517778",
      "osmNodeId": 249517778,
      "wgs84": {
        "latitude": 54.7166414,
        "longitude": 25.3164756
      },
      "lks94": {
        "easting": 584819.934,
        "northing": 6065268.941
      }
    },
    {
      "id": "osm:node:249523651",
      "osmNodeId": 249523651,
      "wgs84": {
        "latitude": 54.7247077,
        "longitude": 25.3317891
      },
      "lks94": {
        "easting": 585789.481,
        "northing": 6066185.224
      }
    },
    {
      "id": "osm:node:253276504",
      "osmNodeId": 253276504,
      "wgs84": {
        "latitude": 54.6658098,
        "longitude": 25.272886
      },
      "lks94": {
        "easting": 582114.205,
        "northing": 6059560.262
      }
    },
    {
      "id": "osm:node:267147828",
      "osmNodeId": 267147828,
      "wgs84": {
        "latitude": 54.697951,
        "longitude": 25.300877
      },
      "lks94": {
        "easting": 583853.534,
        "northing": 6063170.214
      }
    },
    {
      "id": "osm:node:267148642",
      "osmNodeId": 267148642,
      "wgs84": {
        "latitude": 54.6986622,
        "longitude": 25.2868457
      },
      "lks94": {
        "easting": 582947.687,
        "northing": 6063232.69
      }
    },
    {
      "id": "osm:node:268069558",
      "osmNodeId": 268069558,
      "wgs84": {
        "latitude": 54.7448795,
        "longitude": 25.2778704
      },
      "lks94": {
        "easting": 582275.525,
        "northing": 6068365.503
      }
    },
    {
      "id": "osm:node:268069623",
      "osmNodeId": 268069623,
      "wgs84": {
        "latitude": 54.7381444,
        "longitude": 25.269986
      },
      "lks94": {
        "easting": 581781.485,
        "northing": 6067606.754
      }
    },
    {
      "id": "osm:node:268069677",
      "osmNodeId": 268069677,
      "wgs84": {
        "latitude": 54.7435716,
        "longitude": 25.2772993
      },
      "lks94": {
        "easting": 582241.407,
        "northing": 6068219.281
      }
    },
    {
      "id": "osm:node:270264152",
      "osmNodeId": 270264152,
      "wgs84": {
        "latitude": 54.643101,
        "longitude": 25.2777602
      },
      "lks94": {
        "easting": 582474.601,
        "northing": 6057038.806
      }
    },
    {
      "id": "osm:node:270955210",
      "osmNodeId": 270955210,
      "wgs84": {
        "latitude": 54.6442248,
        "longitude": 25.2055775
      },
      "lks94": {
        "easting": 577813.567,
        "northing": 6057081.515
      }
    },
    {
      "id": "osm:node:273174181",
      "osmNodeId": 273174181,
      "wgs84": {
        "latitude": 54.6828389,
        "longitude": 25.2773304
      },
      "lks94": {
        "easting": 582366.423,
        "northing": 6061460.57
      }
    },
    {
      "id": "osm:node:282776250",
      "osmNodeId": 282776250,
      "wgs84": {
        "latitude": 54.6467872,
        "longitude": 25.211217
      },
      "lks94": {
        "easting": 578172.632,
        "northing": 6057372.937
      }
    },
    {
      "id": "osm:node:283242622",
      "osmNodeId": 283242622,
      "wgs84": {
        "latitude": 54.693578,
        "longitude": 25.2648465
      },
      "lks94": {
        "easting": 581539.931,
        "northing": 6062641.114
      }
    },
    {
      "id": "osm:node:285961690",
      "osmNodeId": 285961690,
      "wgs84": {
        "latitude": 54.662977,
        "longitude": 25.3390013
      },
      "lks94": {
        "easting": 586385.081,
        "northing": 6059324.33
      }
    },
    {
      "id": "osm:node:287898983",
      "osmNodeId": 287898983,
      "wgs84": {
        "latitude": 54.7240308,
        "longitude": 25.3348106
      },
      "lks94": {
        "easting": 585985.538,
        "northing": 6066113.592
      }
    },
    {
      "id": "osm:node:290326304",
      "osmNodeId": 290326304,
      "wgs84": {
        "latitude": 54.6690183,
        "longitude": 25.1042625
      },
      "lks94": {
        "easting": 571231.123,
        "northing": 6059733.222
      }
    },
    {
      "id": "osm:node:303583781",
      "osmNodeId": 303583781,
      "wgs84": {
        "latitude": 54.6855762,
        "longitude": 25.4248856
      },
      "lks94": {
        "easting": 591874.464,
        "northing": 6061948.29
      }
    },
    {
      "id": "osm:node:303766405",
      "osmNodeId": 303766405,
      "wgs84": {
        "latitude": 54.6623809,
        "longitude": 25.2735657
      },
      "lks94": {
        "easting": 582164.97,
        "northing": 6059179.468
      }
    },
    {
      "id": "osm:node:305912311",
      "osmNodeId": 305912311,
      "wgs84": {
        "latitude": 54.7042486,
        "longitude": 25.3159779
      },
      "lks94": {
        "easting": 584813.73,
        "northing": 6063889.192
      }
    },
    {
      "id": "osm:node:308850741",
      "osmNodeId": 308850741,
      "wgs84": {
        "latitude": 54.7120225,
        "longitude": 25.2276429
      },
      "lks94": {
        "easting": 579105.776,
        "northing": 6064651.176
      }
    },
    {
      "id": "osm:node:308850772",
      "osmNodeId": 308850772,
      "wgs84": {
        "latitude": 54.7121463,
        "longitude": 25.2273113
      },
      "lks94": {
        "easting": 579084.169,
        "northing": 6064664.579
      }
    },
    {
      "id": "osm:node:308875686",
      "osmNodeId": 308875686,
      "wgs84": {
        "latitude": 54.7100191,
        "longitude": 25.2491703
      },
      "lks94": {
        "easting": 580496.836,
        "northing": 6064452.699
      }
    },
    {
      "id": "osm:node:308875706",
      "osmNodeId": 308875706,
      "wgs84": {
        "latitude": 54.7108916,
        "longitude": 25.2573282
      },
      "lks94": {
        "easting": 581020.766,
        "northing": 6064559.184
      }
    },
    {
      "id": "osm:node:355918701",
      "osmNodeId": 355918701,
      "wgs84": {
        "latitude": 54.6960147,
        "longitude": 25.307969
      },
      "lks94": {
        "easting": 584314.668,
        "northing": 6062963.226
      }
    },
    {
      "id": "osm:node:372329728",
      "osmNodeId": 372329728,
      "wgs84": {
        "latitude": 54.726171,
        "longitude": 25.2335154
      },
      "lks94": {
        "easting": 579456.488,
        "northing": 6066232.362
      }
    },
    {
      "id": "osm:node:372329733",
      "osmNodeId": 372329733,
      "wgs84": {
        "latitude": 54.7261779,
        "longitude": 25.2338341
      },
      "lks94": {
        "easting": 579477.002,
        "northing": 6066233.49
      }
    },
    {
      "id": "osm:node:374093588",
      "osmNodeId": 374093588,
      "wgs84": {
        "latitude": 54.716194,
        "longitude": 25.2310427
      },
      "lks94": {
        "easting": 579316.695,
        "northing": 6065119.248
      }
    },
    {
      "id": "osm:node:374093963",
      "osmNodeId": 374093963,
      "wgs84": {
        "latitude": 54.7161177,
        "longitude": 25.2305874
      },
      "lks94": {
        "easting": 579287.511,
        "northing": 6065110.243
      }
    },
    {
      "id": "osm:node:374094317",
      "osmNodeId": 374094317,
      "wgs84": {
        "latitude": 54.7160532,
        "longitude": 25.2309581
      },
      "lks94": {
        "easting": 579311.52,
        "northing": 6065103.483
      }
    },
    {
      "id": "osm:node:374095383",
      "osmNodeId": 374095383,
      "wgs84": {
        "latitude": 54.7162559,
        "longitude": 25.2306643
      },
      "lks94": {
        "easting": 579292.195,
        "northing": 6065125.709
      }
    },
    {
      "id": "osm:node:377655292",
      "osmNodeId": 377655292,
      "wgs84": {
        "latitude": 54.7166217,
        "longitude": 25.2283573
      },
      "lks94": {
        "easting": 579142.849,
        "northing": 6065163.814
      }
    },
    {
      "id": "osm:node:377655983",
      "osmNodeId": 377655983,
      "wgs84": {
        "latitude": 54.7167175,
        "longitude": 25.2248237
      },
      "lks94": {
        "easting": 578915.006,
        "northing": 6065170.497
      }
    },
    {
      "id": "osm:node:377656150",
      "osmNodeId": 377656150,
      "wgs84": {
        "latitude": 54.7170312,
        "longitude": 25.221584
      },
      "lks94": {
        "easting": 578705.676,
        "northing": 6065201.77
      }
    },
    {
      "id": "osm:node:377656165",
      "osmNodeId": 377656165,
      "wgs84": {
        "latitude": 54.7170702,
        "longitude": 25.2213644
      },
      "lks94": {
        "easting": 578691.452,
        "northing": 6065205.864
      }
    },
    {
      "id": "osm:node:414622574",
      "osmNodeId": 414622574,
      "wgs84": {
        "latitude": 54.7104541,
        "longitude": 25.1750856
      },
      "lks94": {
        "easting": 575722.219,
        "northing": 6064418.663
      }
    },
    {
      "id": "osm:node:415658005",
      "osmNodeId": 415658005,
      "wgs84": {
        "latitude": 54.6993279,
        "longitude": 25.2434529
      },
      "lks94": {
        "easting": 580149.503,
        "northing": 6063256.364
      }
    },
    {
      "id": "osm:node:415658010",
      "osmNodeId": 415658010,
      "wgs84": {
        "latitude": 54.6994168,
        "longitude": 25.2432675
      },
      "lks94": {
        "easting": 580137.378,
        "northing": 6063266.046
      }
    },
    {
      "id": "osm:node:416128719",
      "osmNodeId": 416128719,
      "wgs84": {
        "latitude": 54.6908545,
        "longitude": 25.2984233
      },
      "lks94": {
        "easting": 583709.987,
        "northing": 6062377.543
      }
    },
    {
      "id": "osm:node:419541946",
      "osmNodeId": 419541946,
      "wgs84": {
        "latitude": 54.8054671,
        "longitude": 25.2736464
      },
      "lks94": {
        "easting": 581881.118,
        "northing": 6075103.227
      }
    },
    {
      "id": "osm:node:419542269",
      "osmNodeId": 419542269,
      "wgs84": {
        "latitude": 54.7824565,
        "longitude": 25.2751526
      },
      "lks94": {
        "easting": 582024.519,
        "northing": 6072544.178
      }
    },
    {
      "id": "osm:node:419542293",
      "osmNodeId": 419542293,
      "wgs84": {
        "latitude": 54.7580306,
        "longitude": 25.27215
      },
      "lks94": {
        "easting": 581880.696,
        "northing": 6069822.363
      }
    },
    {
      "id": "osm:node:429279420",
      "osmNodeId": 429279420,
      "wgs84": {
        "latitude": 54.7017434,
        "longitude": 25.2632755
      },
      "lks94": {
        "easting": 581422.306,
        "northing": 6063547.991
      }
    },
    {
      "id": "osm:node:441603487",
      "osmNodeId": 441603487,
      "wgs84": {
        "latitude": 54.6787112,
        "longitude": 25.2575935
      },
      "lks94": {
        "easting": 581102.02,
        "northing": 6060978.238
      }
    },
    {
      "id": "osm:node:449399063",
      "osmNodeId": 449399063,
      "wgs84": {
        "latitude": 54.7219349,
        "longitude": 25.2843217
      },
      "lks94": {
        "easting": 582737.608,
        "northing": 6065819.651
      }
    },
    {
      "id": "osm:node:449400465",
      "osmNodeId": 449400465,
      "wgs84": {
        "latitude": 54.7396435,
        "longitude": 25.2269222
      },
      "lks94": {
        "easting": 579005.593,
        "northing": 6067724.242
      }
    },
    {
      "id": "osm:node:449400467",
      "osmNodeId": 449400467,
      "wgs84": {
        "latitude": 54.7397206,
        "longitude": 25.2270775
      },
      "lks94": {
        "easting": 579015.442,
        "northing": 6067732.997
      }
    },
    {
      "id": "osm:node:461898556",
      "osmNodeId": 461898556,
      "wgs84": {
        "latitude": 54.6681667,
        "longitude": 25.2640024
      },
      "lks94": {
        "easting": 581536.431,
        "northing": 6059812.201
      }
    },
    {
      "id": "osm:node:679279292",
      "osmNodeId": 679279292,
      "wgs84": {
        "latitude": 54.6785318,
        "longitude": 25.3116116
      },
      "lks94": {
        "easting": 584585.815,
        "northing": 6061022.007
      }
    },
    {
      "id": "osm:node:749952755",
      "osmNodeId": 749952755,
      "wgs84": {
        "latitude": 54.649626,
        "longitude": 25.2683254
      },
      "lks94": {
        "easting": 581852.541,
        "northing": 6057753.909
      }
    },
    {
      "id": "osm:node:758635878",
      "osmNodeId": 758635878,
      "wgs84": {
        "latitude": 54.6965449,
        "longitude": 25.3084393
      },
      "lks94": {
        "easting": 584343.883,
        "northing": 6063022.794
      }
    },
    {
      "id": "osm:node:760612625",
      "osmNodeId": 760612625,
      "wgs84": {
        "latitude": 54.7019916,
        "longitude": 25.3094918
      },
      "lks94": {
        "easting": 584400.416,
        "northing": 6063630.201
      }
    },
    {
      "id": "osm:node:776165064",
      "osmNodeId": 776165064,
      "wgs84": {
        "latitude": 54.731706,
        "longitude": 25.2310424
      },
      "lks94": {
        "easting": 579286.391,
        "northing": 6066845.542
      }
    },
    {
      "id": "osm:node:831359945",
      "osmNodeId": 831359945,
      "wgs84": {
        "latitude": 54.7347315,
        "longitude": 25.2566823
      },
      "lks94": {
        "easting": 580931.634,
        "northing": 6067211.515
      }
    },
    {
      "id": "osm:node:931820206",
      "osmNodeId": 931820206,
      "wgs84": {
        "latitude": 54.7162631,
        "longitude": 25.3053292
      },
      "lks94": {
        "easting": 584102.601,
        "northing": 6065213.427
      }
    },
    {
      "id": "osm:node:937512682",
      "osmNodeId": 937512682,
      "wgs84": {
        "latitude": 54.7100163,
        "longitude": 25.2490277
      },
      "lks94": {
        "easting": 580487.653,
        "northing": 6064452.224
      }
    },
    {
      "id": "osm:node:941660545",
      "osmNodeId": 941660545,
      "wgs84": {
        "latitude": 54.7302097,
        "longitude": 25.235817
      },
      "lks94": {
        "easting": 579596.821,
        "northing": 6066684.428
      }
    },
    {
      "id": "osm:node:942647835",
      "osmNodeId": 942647835,
      "wgs84": {
        "latitude": 54.744854,
        "longitude": 25.2780394
      },
      "lks94": {
        "easting": 582286.457,
        "northing": 6068362.864
      }
    },
    {
      "id": "osm:node:1219553020",
      "osmNodeId": 1219553020,
      "wgs84": {
        "latitude": 54.6982601,
        "longitude": 25.2737585
      },
      "lks94": {
        "easting": 582104.968,
        "northing": 6063172.556
      }
    },
    {
      "id": "osm:node:1344671612",
      "osmNodeId": 1344671612,
      "wgs84": {
        "latitude": 54.7435503,
        "longitude": 25.2774912
      },
      "lks94": {
        "easting": 582253.805,
        "northing": 6068217.136
      }
    },
    {
      "id": "osm:node:1370389233",
      "osmNodeId": 1370389233,
      "wgs84": {
        "latitude": 54.722797,
        "longitude": 25.2433409
      },
      "lks94": {
        "easting": 580096.014,
        "northing": 6065868.047
      }
    },
    {
      "id": "osm:node:1385675192",
      "osmNodeId": 1385675192,
      "wgs84": {
        "latitude": 54.6932204,
        "longitude": 25.2147976
      },
      "lks94": {
        "easting": 578314.318,
        "northing": 6062544.335
      }
    },
    {
      "id": "osm:node:1597662295",
      "osmNodeId": 1597662295,
      "wgs84": {
        "latitude": 54.7343885,
        "longitude": 25.3376444
      },
      "lks94": {
        "easting": 586146.099,
        "northing": 6067269.737
      }
    },
    {
      "id": "osm:node:1607436967",
      "osmNodeId": 1607436967,
      "wgs84": {
        "latitude": 54.686117,
        "longitude": 25.3242232
      },
      "lks94": {
        "easting": 585383.167,
        "northing": 6061881.397
      }
    },
    {
      "id": "osm:node:1616728181",
      "osmNodeId": 1616728181,
      "wgs84": {
        "latitude": 54.7240138,
        "longitude": 25.3349798
      },
      "lks94": {
        "easting": 585996.472,
        "northing": 6066111.908
      }
    },
    {
      "id": "osm:node:1616788404",
      "osmNodeId": 1616788404,
      "wgs84": {
        "latitude": 54.6732446,
        "longitude": 25.2402179
      },
      "lks94": {
        "easting": 579992.274,
        "northing": 6060349.947
      }
    },
    {
      "id": "osm:node:1657184191",
      "osmNodeId": 1657184191,
      "wgs84": {
        "latitude": 54.6934217,
        "longitude": 25.2810141
      },
      "lks94": {
        "easting": 582582.456,
        "northing": 6062642.618
      }
    },
    {
      "id": "osm:node:1780507271",
      "osmNodeId": 1780507271,
      "wgs84": {
        "latitude": 54.6528916,
        "longitude": 25.2825014
      },
      "lks94": {
        "easting": 582760.716,
        "northing": 6058133.936
      }
    },
    {
      "id": "osm:node:1983105368",
      "osmNodeId": 1983105368,
      "wgs84": {
        "latitude": 54.7368852,
        "longitude": 25.230907
      },
      "lks94": {
        "easting": 579267.559,
        "northing": 6067421.771
      }
    },
    {
      "id": "osm:node:2145164984",
      "osmNodeId": 2145164984,
      "wgs84": {
        "latitude": 54.7262776,
        "longitude": 25.2335106
      },
      "lks94": {
        "easting": 579455.97,
        "northing": 6066244.219
      }
    },
    {
      "id": "osm:node:2207331638",
      "osmNodeId": 2207331638,
      "wgs84": {
        "latitude": 54.7112953,
        "longitude": 25.3047759
      },
      "lks94": {
        "easting": 584077.233,
        "northing": 6064659.915
      }
    },
    {
      "id": "osm:node:2225194079",
      "osmNodeId": 2225194079,
      "wgs84": {
        "latitude": 54.7240215,
        "longitude": 25.3207963
      },
      "lks94": {
        "easting": 585082.84,
        "northing": 6066095.475
      }
    },
    {
      "id": "osm:node:2264346537",
      "osmNodeId": 2264346537,
      "wgs84": {
        "latitude": 54.7397841,
        "longitude": 25.2269823
      },
      "lks94": {
        "easting": 579009.189,
        "northing": 6067739.957
      }
    },
    {
      "id": "osm:node:2269140062",
      "osmNodeId": 2269140062,
      "wgs84": {
        "latitude": 54.693507,
        "longitude": 25.2887467
      },
      "lks94": {
        "easting": 583080.748,
        "northing": 6062661.235
      }
    },
    {
      "id": "osm:node:2314372291",
      "osmNodeId": 2314372291,
      "wgs84": {
        "latitude": 54.6902476,
        "longitude": 25.2728541
      },
      "lks94": {
        "easting": 582062.843,
        "northing": 6062279.815
      }
    },
    {
      "id": "osm:node:2343137752",
      "osmNodeId": 2343137752,
      "wgs84": {
        "latitude": 54.7262797,
        "longitude": 25.2338315
      },
      "lks94": {
        "easting": 579476.635,
        "northing": 6066244.817
      }
    },
    {
      "id": "osm:node:2381174075",
      "osmNodeId": 2381174075,
      "wgs84": {
        "latitude": 54.7507945,
        "longitude": 25.2764147
      },
      "lks94": {
        "easting": 582169.828,
        "northing": 6069022.062
      }
    },
    {
      "id": "osm:node:2419955225",
      "osmNodeId": 2419955225,
      "wgs84": {
        "latitude": 54.6515911,
        "longitude": 25.2822144
      },
      "lks94": {
        "easting": 582744.839,
        "northing": 6057988.871
      }
    },
    {
      "id": "osm:node:2493797189",
      "osmNodeId": 2493797189,
      "wgs84": {
        "latitude": 54.7015483,
        "longitude": 25.2049206
      },
      "lks94": {
        "easting": 577661.7,
        "northing": 6063460.153
      }
    },
    {
      "id": "osm:node:2681738020",
      "osmNodeId": 2681738020,
      "wgs84": {
        "latitude": 54.678705,
        "longitude": 25.278732
      },
      "lks94": {
        "easting": 582465.177,
        "northing": 6061002.169
      }
    },
    {
      "id": "osm:node:2752159032",
      "osmNodeId": 2752159032,
      "wgs84": {
        "latitude": 54.7798582,
        "longitude": 25.2745934
      },
      "lks94": {
        "easting": 581993.807,
        "northing": 6072254.364
      }
    },
    {
      "id": "osm:node:2752159044",
      "osmNodeId": 2752159044,
      "wgs84": {
        "latitude": 54.7800271,
        "longitude": 25.2744458
      },
      "lks94": {
        "easting": 581983.971,
        "northing": 6072272.988
      }
    },
    {
      "id": "osm:node:2783662182",
      "osmNodeId": 2783662182,
      "wgs84": {
        "latitude": 54.6919976,
        "longitude": 25.2892393
      },
      "lks94": {
        "easting": 583115.587,
        "northing": 6062493.843
      }
    },
    {
      "id": "osm:node:2820512576",
      "osmNodeId": 2820512576,
      "wgs84": {
        "latitude": 54.6500961,
        "longitude": 25.2787651
      },
      "lks94": {
        "easting": 582525.288,
        "northing": 6057818.44
      }
    },
    {
      "id": "osm:node:2820513004",
      "osmNodeId": 2820513004,
      "wgs84": {
        "latitude": 54.6528122,
        "longitude": 25.2824839
      },
      "lks94": {
        "easting": 582759.749,
        "northing": 6058125.079
      }
    },
    {
      "id": "osm:node:2820555582",
      "osmNodeId": 2820555582,
      "wgs84": {
        "latitude": 54.6516574,
        "longitude": 25.2822287
      },
      "lks94": {
        "easting": 582745.627,
        "northing": 6057996.266
      }
    },
    {
      "id": "osm:node:2820555584",
      "osmNodeId": 2820555584,
      "wgs84": {
        "latitude": 54.6515709,
        "longitude": 25.2824262
      },
      "lks94": {
        "easting": 582758.548,
        "northing": 6057986.872
      }
    },
    {
      "id": "osm:node:2829767432",
      "osmNodeId": 2829767432,
      "wgs84": {
        "latitude": 54.7058909,
        "longitude": 25.3080959
      },
      "lks94": {
        "easting": 584302.364,
        "northing": 6064062.462
      }
    },
    {
      "id": "osm:node:2916048793",
      "osmNodeId": 2916048793,
      "wgs84": {
        "latitude": 54.6239295,
        "longitude": 25.1112534
      },
      "lks94": {
        "easting": 571761.442,
        "northing": 6054722.5
      }
    },
    {
      "id": "osm:node:2938953187",
      "osmNodeId": 2938953187,
      "wgs84": {
        "latitude": 54.6800301,
        "longitude": 25.260209
      },
      "lks94": {
        "easting": 581268.049,
        "northing": 6061128.038
      }
    },
    {
      "id": "osm:node:3002823152",
      "osmNodeId": 3002823152,
      "wgs84": {
        "latitude": 54.6626117,
        "longitude": 25.3413383
      },
      "lks94": {
        "easting": 586536.619,
        "northing": 6059286.555
      }
    },
    {
      "id": "osm:node:3256519641",
      "osmNodeId": 3256519641,
      "wgs84": {
        "latitude": 54.6327766,
        "longitude": 25.1516302
      },
      "lks94": {
        "easting": 574352.603,
        "northing": 6055749.054
      }
    },
    {
      "id": "osm:node:3279438538",
      "osmNodeId": 3279438538,
      "wgs84": {
        "latitude": 54.6962555,
        "longitude": 25.2559977
      },
      "lks94": {
        "easting": 580964.181,
        "northing": 6062928.842
      }
    },
    {
      "id": "osm:node:3331149442",
      "osmNodeId": 3331149442,
      "wgs84": {
        "latitude": 54.7369705,
        "longitude": 25.2310441
      },
      "lks94": {
        "easting": 579276.221,
        "northing": 6067431.419
      }
    },
    {
      "id": "osm:node:3409854949",
      "osmNodeId": 3409854949,
      "wgs84": {
        "latitude": 54.7545385,
        "longitude": 25.3651927
      },
      "lks94": {
        "easting": 587876.497,
        "northing": 6069546.322
      }
    },
    {
      "id": "osm:node:3409854950",
      "osmNodeId": 3409854950,
      "wgs84": {
        "latitude": 54.7544647,
        "longitude": 25.3653893
      },
      "lks94": {
        "easting": 587889.312,
        "northing": 6069538.355
      }
    },
    {
      "id": "osm:node:3414201533",
      "osmNodeId": 3414201533,
      "wgs84": {
        "latitude": 54.7029432,
        "longitude": 25.309821
      },
      "lks94": {
        "easting": 584419.657,
        "northing": 6063736.497
      }
    },
    {
      "id": "osm:node:3414962244",
      "osmNodeId": 3414962244,
      "wgs84": {
        "latitude": 54.7088465,
        "longitude": 25.3133463
      },
      "lks94": {
        "easting": 584634.561,
        "northing": 6064397.698
      }
    },
    {
      "id": "osm:node:3422969215",
      "osmNodeId": 3422969215,
      "wgs84": {
        "latitude": 54.7573762,
        "longitude": 25.2810145
      },
      "lks94": {
        "easting": 582452.549,
        "northing": 6069759.92
      },
      "direction": "both"
    },
    {
      "id": "osm:node:3422969221",
      "osmNodeId": 3422969221,
      "wgs84": {
        "latitude": 54.7580324,
        "longitude": 25.2719474
      },
      "lks94": {
        "easting": 581867.653,
        "northing": 6069822.327
      }
    },
    {
      "id": "osm:node:3665994833",
      "osmNodeId": 3665994833,
      "wgs84": {
        "latitude": 54.7447692,
        "longitude": 25.2198578
      },
      "lks94": {
        "easting": 578540.797,
        "northing": 6068286.739
      }
    },
    {
      "id": "osm:node:3713068141",
      "osmNodeId": 3713068141,
      "wgs84": {
        "latitude": 54.7357154,
        "longitude": 25.2119232
      },
      "lks94": {
        "easting": 578047.357,
        "northing": 6067270.305
      }
    },
    {
      "id": "osm:node:3744520695",
      "osmNodeId": 3744520695,
      "wgs84": {
        "latitude": 54.7038509,
        "longitude": 25.3101515
      },
      "lks94": {
        "easting": 584439.071,
        "northing": 6063837.909
      }
    },
    {
      "id": "osm:node:3900951734",
      "osmNodeId": 3900951734,
      "wgs84": {
        "latitude": 54.7343439,
        "longitude": 25.3377434
      },
      "lks94": {
        "easting": 586152.569,
        "northing": 6067264.895
      }
    },
    {
      "id": "osm:node:3956301189",
      "osmNodeId": 3956301189,
      "wgs84": {
        "latitude": 54.7016626,
        "longitude": 25.2628846
      },
      "lks94": {
        "easting": 581397.275,
        "northing": 6063538.545
      }
    },
    {
      "id": "osm:node:4003376932",
      "osmNodeId": 4003376932,
      "wgs84": {
        "latitude": 54.6662736,
        "longitude": 25.2545356
      },
      "lks94": {
        "easting": 580929.556,
        "northing": 6059590.574
      },
      "direction": "both"
    },
    {
      "id": "osm:node:4311938617",
      "osmNodeId": 4311938617,
      "wgs84": {
        "latitude": 54.6975467,
        "longitude": 25.2712928
      },
      "lks94": {
        "easting": 581947.479,
        "northing": 6063090.283
      }
    },
    {
      "id": "osm:node:4339653275",
      "osmNodeId": 4339653275,
      "wgs84": {
        "latitude": 54.6719877,
        "longitude": 25.2565393
      },
      "lks94": {
        "easting": 581047.428,
        "northing": 6060228.786
      }
    },
    {
      "id": "osm:node:4342336891",
      "osmNodeId": 4342336891,
      "wgs84": {
        "latitude": 54.810618,
        "longitude": 25.4161877
      },
      "lks94": {
        "easting": 591032.743,
        "northing": 6075852.256
      }
    },
    {
      "id": "osm:node:4382053093",
      "osmNodeId": 4382053093,
      "wgs84": {
        "latitude": 54.6238252,
        "longitude": 25.1113385
      },
      "lks94": {
        "easting": 571767.12,
        "northing": 6054710.98
      }
    },
    {
      "id": "osm:node:4393942549",
      "osmNodeId": 4393942549,
      "wgs84": {
        "latitude": 54.6946626,
        "longitude": 25.2817081
      },
      "lks94": {
        "easting": 582624.672,
        "northing": 6062781.53
      }
    },
    {
      "id": "osm:node:4406973260",
      "osmNodeId": 4406973260,
      "wgs84": {
        "latitude": 54.7357696,
        "longitude": 25.2076881
      },
      "lks94": {
        "easting": 577774.528,
        "northing": 6067271.634
      }
    },
    {
      "id": "osm:node:4406973418",
      "osmNodeId": 4406973418,
      "wgs84": {
        "latitude": 54.7357649,
        "longitude": 25.2088399
      },
      "lks94": {
        "easting": 577848.708,
        "northing": 6067272.388
      }
    },
    {
      "id": "osm:node:4549020189",
      "osmNodeId": 4549020189,
      "wgs84": {
        "latitude": 54.7293899,
        "longitude": 25.2364003
      },
      "lks94": {
        "easting": 579635.996,
        "northing": 6066593.856
      }
    },
    {
      "id": "osm:node:4549020191",
      "osmNodeId": 4549020191,
      "wgs84": {
        "latitude": 54.7292385,
        "longitude": 25.2365582
      },
      "lks94": {
        "easting": 579646.462,
        "northing": 6066577.186
      }
    },
    {
      "id": "osm:node:4549020195",
      "osmNodeId": 4549020195,
      "wgs84": {
        "latitude": 54.7301818,
        "longitude": 25.2355971
      },
      "lks94": {
        "easting": 579582.713,
        "northing": 6066681.073
      }
    },
    {
      "id": "osm:node:4730497546",
      "osmNodeId": 4730497546,
      "wgs84": {
        "latitude": 54.7648313,
        "longitude": 25.2719836
      },
      "lks94": {
        "easting": 581856.261,
        "northing": 6070579.004
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:4839428231",
      "osmNodeId": 4839428231,
      "wgs84": {
        "latitude": 54.7054362,
        "longitude": 25.2058307
      },
      "lks94": {
        "easting": 577712.923,
        "northing": 6063893.835
      }
    },
    {
      "id": "osm:node:5085090346",
      "osmNodeId": 5085090346,
      "wgs84": {
        "latitude": 54.7187957,
        "longitude": 25.299695
      },
      "lks94": {
        "easting": 583734.39,
        "northing": 6065488.534
      }
    },
    {
      "id": "osm:node:5329978765",
      "osmNodeId": 5329978765,
      "wgs84": {
        "latitude": 54.8100633,
        "longitude": 25.415089
      },
      "lks94": {
        "easting": 590963.369,
        "northing": 6075789.099
      }
    },
    {
      "id": "osm:node:5329978766",
      "osmNodeId": 5329978766,
      "wgs84": {
        "latitude": 54.810134,
        "longitude": 25.4149511
      },
      "lks94": {
        "easting": 590954.347,
        "northing": 6075796.788
      }
    },
    {
      "id": "osm:node:5680463110",
      "osmNodeId": 5680463110,
      "wgs84": {
        "latitude": 54.7029083,
        "longitude": 25.2651449
      },
      "lks94": {
        "easting": 581540.452,
        "northing": 6063679.799
      }
    },
    {
      "id": "osm:node:7194944174",
      "osmNodeId": 7194944174,
      "wgs84": {
        "latitude": 54.669548,
        "longitude": 25.2577494
      },
      "lks94": {
        "easting": 581130.339,
        "northing": 6059958.678
      }
    },
    {
      "id": "osm:node:7543243127",
      "osmNodeId": 7543243127,
      "wgs84": {
        "latitude": 54.6441623,
        "longitude": 25.2057671
      },
      "lks94": {
        "easting": 577825.924,
        "northing": 6057074.769
      }
    },
    {
      "id": "osm:node:8718159169",
      "osmNodeId": 8718159169,
      "wgs84": {
        "latitude": 54.6547156,
        "longitude": 25.3028272
      },
      "lks94": {
        "easting": 584068.515,
        "northing": 6058361.06
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:9276043157",
      "osmNodeId": 9276043157,
      "wgs84": {
        "latitude": 54.7134375,
        "longitude": 25.2868416
      },
      "lks94": {
        "easting": 582917.275,
        "northing": 6064876.977
      }
    },
    {
      "id": "osm:node:9352431231",
      "osmNodeId": 9352431231,
      "wgs84": {
        "latitude": 54.6702589,
        "longitude": 25.2589389
      },
      "lks94": {
        "easting": 581205.645,
        "northing": 6060039.167
      }
    },
    {
      "id": "osm:node:9352431232",
      "osmNodeId": 9352431232,
      "wgs84": {
        "latitude": 54.6701759,
        "longitude": 25.2590765
      },
      "lks94": {
        "easting": 581214.686,
        "northing": 6060030.089
      }
    },
    {
      "id": "osm:node:9352431234",
      "osmNodeId": 9352431234,
      "wgs84": {
        "latitude": 54.6701054,
        "longitude": 25.2602774
      },
      "lks94": {
        "easting": 581292.284,
        "northing": 6060023.633
      }
    },
    {
      "id": "osm:node:9352431236",
      "osmNodeId": 9352431236,
      "wgs84": {
        "latitude": 54.6694899,
        "longitude": 25.2576638
      },
      "lks94": {
        "easting": 581124.934,
        "northing": 6059952.114
      }
    },
    {
      "id": "osm:node:9352431237",
      "osmNodeId": 9352431237,
      "wgs84": {
        "latitude": 54.6694771,
        "longitude": 25.2578929
      },
      "lks94": {
        "easting": 581139.737,
        "northing": 6059950.954
      }
    },
    {
      "id": "osm:node:9352431245",
      "osmNodeId": 9352431245,
      "wgs84": {
        "latitude": 54.6694202,
        "longitude": 25.2577949
      },
      "lks94": {
        "easting": 581133.529,
        "northing": 6059944.509
      }
    },
    {
      "id": "osm:node:9352431247",
      "osmNodeId": 9352431247,
      "wgs84": {
        "latitude": 54.6702622,
        "longitude": 25.2592484
      },
      "lks94": {
        "easting": 581225.601,
        "northing": 6060039.892
      }
    },
    {
      "id": "osm:node:9832793974",
      "osmNodeId": 9832793974,
      "wgs84": {
        "latitude": 54.720222,
        "longitude": 25.3176606
      },
      "lks94": {
        "easting": 584888.797,
        "northing": 6065668.845
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:9832793975",
      "osmNodeId": 9832793975,
      "wgs84": {
        "latitude": 54.7203391,
        "longitude": 25.317724
      },
      "lks94": {
        "easting": 584892.637,
        "northing": 6065681.954
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:9916442092",
      "osmNodeId": 9916442092,
      "wgs84": {
        "latitude": 54.7132145,
        "longitude": 25.2784364
      },
      "lks94": {
        "easting": 582376.17,
        "northing": 6064842.263
      }
    },
    {
      "id": "osm:node:9916442093",
      "osmNodeId": 9916442093,
      "wgs84": {
        "latitude": 54.7129925,
        "longitude": 25.277838
      },
      "lks94": {
        "easting": 582338.064,
        "northing": 6064816.855
      }
    },
    {
      "id": "osm:node:9916442094",
      "osmNodeId": 9916442094,
      "wgs84": {
        "latitude": 54.7147927,
        "longitude": 25.2869447
      },
      "lks94": {
        "easting": 582921.152,
        "northing": 6065027.915
      }
    },
    {
      "id": "osm:node:9916442095",
      "osmNodeId": 9916442095,
      "wgs84": {
        "latitude": 54.7152856,
        "longitude": 25.2867274
      },
      "lks94": {
        "easting": 582906.146,
        "northing": 6065082.511
      }
    },
    {
      "id": "osm:node:9916442096",
      "osmNodeId": 9916442096,
      "wgs84": {
        "latitude": 54.7149738,
        "longitude": 25.2863967
      },
      "lks94": {
        "easting": 582885.476,
        "northing": 6065047.422
      }
    },
    {
      "id": "osm:node:9916442097",
      "osmNodeId": 9916442097,
      "wgs84": {
        "latitude": 54.7151286,
        "longitude": 25.2872696
      },
      "lks94": {
        "easting": 582941.399,
        "northing": 6065065.68
      }
    },
    {
      "id": "osm:node:9916442098",
      "osmNodeId": 9916442098,
      "wgs84": {
        "latitude": 54.7171229,
        "longitude": 25.2861186
      },
      "lks94": {
        "easting": 582863.175,
        "northing": 6065286.259
      }
    },
    {
      "id": "osm:node:9916442099",
      "osmNodeId": 9916442099,
      "wgs84": {
        "latitude": 54.7174393,
        "longitude": 25.2864014
      },
      "lks94": {
        "easting": 582880.749,
        "northing": 6065321.804
      }
    },
    {
      "id": "osm:node:9916442100",
      "osmNodeId": 9916442100,
      "wgs84": {
        "latitude": 54.7169645,
        "longitude": 25.286803
      },
      "lks94": {
        "easting": 582907.591,
        "northing": 6065269.44
      }
    },
    {
      "id": "osm:node:10028859890",
      "osmNodeId": 10028859890,
      "wgs84": {
        "latitude": 54.6738566,
        "longitude": 25.2480958
      },
      "lks94": {
        "easting": 580499.15,
        "northing": 6060427.057
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10028859891",
      "osmNodeId": 10028859891,
      "wgs84": {
        "latitude": 54.6736402,
        "longitude": 25.2476648
      },
      "lks94": {
        "easting": 580471.781,
        "northing": 6060402.481
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10067403460",
      "osmNodeId": 10067403460,
      "wgs84": {
        "latitude": 54.6974297,
        "longitude": 25.2711934
      },
      "lks94": {
        "easting": 581941.308,
        "northing": 6063077.147
      }
    },
    {
      "id": "osm:node:10067403468",
      "osmNodeId": 10067403468,
      "wgs84": {
        "latitude": 54.6981954,
        "longitude": 25.267642
      },
      "lks94": {
        "easting": 581710.857,
        "northing": 6063158.219
      }
    },
    {
      "id": "osm:node:10067403481",
      "osmNodeId": 10067403481,
      "wgs84": {
        "latitude": 54.6960978,
        "longitude": 25.2750914
      },
      "lks94": {
        "easting": 582195.252,
        "northing": 6062933.481
      }
    },
    {
      "id": "osm:node:10067403487",
      "osmNodeId": 10067403487,
      "wgs84": {
        "latitude": 54.6949913,
        "longitude": 25.2793909
      },
      "lks94": {
        "easting": 582474.636,
        "northing": 6062815.385
      }
    },
    {
      "id": "osm:node:10067403493",
      "osmNodeId": 10067403493,
      "wgs84": {
        "latitude": 54.6947619,
        "longitude": 25.2819065
      },
      "lks94": {
        "easting": 582637.259,
        "northing": 6062792.815
      }
    },
    {
      "id": "osm:node:10067403494",
      "osmNodeId": 10067403494,
      "wgs84": {
        "latitude": 54.6946394,
        "longitude": 25.2818913
      },
      "lks94": {
        "easting": 582636.528,
        "northing": 6062779.164
      }
    },
    {
      "id": "osm:node:10099082580",
      "osmNodeId": 10099082580,
      "wgs84": {
        "latitude": 54.7150439,
        "longitude": 25.3159948
      },
      "lks94": {
        "easting": 584792.292,
        "northing": 6065090.58
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10099082581",
      "osmNodeId": 10099082581,
      "wgs84": {
        "latitude": 54.7148463,
        "longitude": 25.3159293
      },
      "lks94": {
        "easting": 584788.485,
        "northing": 6065068.511
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10212377082",
      "osmNodeId": 10212377082,
      "wgs84": {
        "latitude": 54.7451168,
        "longitude": 25.2205761
      },
      "lks94": {
        "easting": 578586.369,
        "northing": 6068326.227
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10212377083",
      "osmNodeId": 10212377083,
      "wgs84": {
        "latitude": 54.7448007,
        "longitude": 25.2205108
      },
      "lks94": {
        "easting": 578582.777,
        "northing": 6068290.976
      }
    },
    {
      "id": "osm:node:10212377084",
      "osmNodeId": 10212377084,
      "wgs84": {
        "latitude": 54.7451133,
        "longitude": 25.2199146
      },
      "lks94": {
        "easting": 578543.788,
        "northing": 6068325.097
      }
    },
    {
      "id": "osm:node:10271232576",
      "osmNodeId": 10271232576,
      "wgs84": {
        "latitude": 54.7096635,
        "longitude": 25.2264274
      },
      "lks94": {
        "easting": 579032.045,
        "northing": 6064387.279
      }
    },
    {
      "id": "osm:node:10293378133",
      "osmNodeId": 10293378133,
      "wgs84": {
        "latitude": 54.7356336,
        "longitude": 25.2076907
      },
      "lks94": {
        "easting": 577774.955,
        "northing": 6067256.501
      }
    },
    {
      "id": "osm:node:10293378134",
      "osmNodeId": 10293378134,
      "wgs84": {
        "latitude": 54.7356309,
        "longitude": 25.2087813
      },
      "lks94": {
        "easting": 577845.192,
        "northing": 6067257.41
      }
    },
    {
      "id": "osm:node:10293378145",
      "osmNodeId": 10293378145,
      "wgs84": {
        "latitude": 54.7356445,
        "longitude": 25.2119212
      },
      "lks94": {
        "easting": 578047.364,
        "northing": 6067262.412
      }
    },
    {
      "id": "osm:node:10311986736",
      "osmNodeId": 10311986736,
      "wgs84": {
        "latitude": 54.6910072,
        "longitude": 25.2764904
      },
      "lks94": {
        "easting": 582295.731,
        "northing": 6062368.605
      }
    },
    {
      "id": "osm:node:10312962735",
      "osmNodeId": 10312962735,
      "wgs84": {
        "latitude": 54.6742457,
        "longitude": 25.2849919
      },
      "lks94": {
        "easting": 582877.936,
        "northing": 6060513.281
      }
    },
    {
      "id": "osm:node:10608844726",
      "osmNodeId": 10608844726,
      "wgs84": {
        "latitude": 54.6614695,
        "longitude": 25.2733959
      },
      "lks94": {
        "easting": 582155.855,
        "northing": 6059077.844
      }
    },
    {
      "id": "osm:node:10608844733",
      "osmNodeId": 10608844733,
      "wgs84": {
        "latitude": 54.6631306,
        "longitude": 25.2732831
      },
      "lks94": {
        "easting": 582145.226,
        "northing": 6059262.569
      }
    },
    {
      "id": "osm:node:10608844738",
      "osmNodeId": 10608844738,
      "wgs84": {
        "latitude": 54.6624578,
        "longitude": 25.2734085
      },
      "lks94": {
        "easting": 582154.674,
        "northing": 6059187.842
      }
    },
    {
      "id": "osm:node:10701410617",
      "osmNodeId": 10701410617,
      "wgs84": {
        "latitude": 54.7312048,
        "longitude": 25.3326428
      },
      "lks94": {
        "easting": 585830.738,
        "northing": 6066909.305
      }
    },
    {
      "id": "osm:node:10701410618",
      "osmNodeId": 10701410618,
      "wgs84": {
        "latitude": 54.73107,
        "longitude": 25.3326175
      },
      "lks94": {
        "easting": 585829.394,
        "northing": 6066894.273
      }
    },
    {
      "id": "osm:node:10765598904",
      "osmNodeId": 10765598904,
      "wgs84": {
        "latitude": 54.6587832,
        "longitude": 25.1601366
      },
      "lks94": {
        "easting": 574853.974,
        "northing": 6058652.292
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10765641706",
      "osmNodeId": 10765641706,
      "wgs84": {
        "latitude": 54.6592405,
        "longitude": 25.1602602
      },
      "lks94": {
        "easting": 574861.108,
        "northing": 6058703.315
      }
    },
    {
      "id": "osm:node:10765641707",
      "osmNodeId": 10765641707,
      "wgs84": {
        "latitude": 54.6587858,
        "longitude": 25.1595991
      },
      "lks94": {
        "easting": 574819.291,
        "northing": 6058652.008
      }
    },
    {
      "id": "osm:node:10814380192",
      "osmNodeId": 10814380192,
      "wgs84": {
        "latitude": 54.6771121,
        "longitude": 25.3033015
      },
      "lks94": {
        "easting": 584052.86,
        "northing": 6060854.036
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10814380193",
      "osmNodeId": 10814380193,
      "wgs84": {
        "latitude": 54.6771416,
        "longitude": 25.3027123
      },
      "lks94": {
        "easting": 584014.802,
        "northing": 6060856.613
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10880575500",
      "osmNodeId": 10880575500,
      "wgs84": {
        "latitude": 54.7191162,
        "longitude": 25.3036001
      },
      "lks94": {
        "easting": 583985.303,
        "northing": 6065528.868
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10880575501",
      "osmNodeId": 10880575501,
      "wgs84": {
        "latitude": 54.7188802,
        "longitude": 25.3038206
      },
      "lks94": {
        "easting": 583999.996,
        "northing": 6065502.868
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10923957693",
      "osmNodeId": 10923957693,
      "wgs84": {
        "latitude": 54.6999354,
        "longitude": 25.2122925
      },
      "lks94": {
        "easting": 578139.924,
        "northing": 6063288.838
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10923957694",
      "osmNodeId": 10923957694,
      "wgs84": {
        "latitude": 54.6994193,
        "longitude": 25.212071
      },
      "lks94": {
        "easting": 578126.639,
        "northing": 6063231.156
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10923957695",
      "osmNodeId": 10923957695,
      "wgs84": {
        "latitude": 54.699611,
        "longitude": 25.2117703
      },
      "lks94": {
        "easting": 578106.889,
        "northing": 6063252.156
      }
    },
    {
      "id": "osm:node:10923957696",
      "osmNodeId": 10923957696,
      "wgs84": {
        "latitude": 54.6997553,
        "longitude": 25.2125333
      },
      "lks94": {
        "easting": 578155.79,
        "northing": 6063269.064
      }
    },
    {
      "id": "osm:node:10923957700",
      "osmNodeId": 10923957700,
      "wgs84": {
        "latitude": 54.7011372,
        "longitude": 25.2043712
      },
      "lks94": {
        "easting": 577627.076,
        "northing": 6063413.795
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10923957701",
      "osmNodeId": 10923957701,
      "wgs84": {
        "latitude": 54.7019439,
        "longitude": 25.2046292
      },
      "lks94": {
        "easting": 577642.164,
        "northing": 6063503.856
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10923957702",
      "osmNodeId": 10923957702,
      "wgs84": {
        "latitude": 54.7016255,
        "longitude": 25.2039781
      },
      "lks94": {
        "easting": 577600.808,
        "northing": 6063467.702
      }
    },
    {
      "id": "osm:node:10926097659",
      "osmNodeId": 10926097659,
      "wgs84": {
        "latitude": 54.7070101,
        "longitude": 25.1866026
      },
      "lks94": {
        "easting": 576470.816,
        "northing": 6064047.873
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10926097660",
      "osmNodeId": 10926097660,
      "wgs84": {
        "latitude": 54.7074206,
        "longitude": 25.1866107
      },
      "lks94": {
        "easting": 576470.566,
        "northing": 6064093.565
      }
    },
    {
      "id": "osm:node:10926097661",
      "osmNodeId": 10926097661,
      "wgs84": {
        "latitude": 54.7072198,
        "longitude": 25.1863053
      },
      "lks94": {
        "easting": 576451.263,
        "northing": 6064070.886
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10926097662",
      "osmNodeId": 10926097662,
      "wgs84": {
        "latitude": 54.7071141,
        "longitude": 25.1869633
      },
      "lks94": {
        "easting": 576493.865,
        "northing": 6064059.84
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10926097665",
      "osmNodeId": 10926097665,
      "wgs84": {
        "latitude": 54.7073426,
        "longitude": 25.175348
      },
      "lks94": {
        "easting": 575744.926,
        "northing": 6064072.673
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10926097666",
      "osmNodeId": 10926097666,
      "wgs84": {
        "latitude": 54.7071645,
        "longitude": 25.1749719
      },
      "lks94": {
        "easting": 575721.021,
        "northing": 6064052.447
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10926097667",
      "osmNodeId": 10926097667,
      "wgs84": {
        "latitude": 54.7075373,
        "longitude": 25.174983
      },
      "lks94": {
        "easting": 575721.042,
        "northing": 6064093.947
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10926097678",
      "osmNodeId": 10926097678,
      "wgs84": {
        "latitude": 54.7105446,
        "longitude": 25.1820504
      },
      "lks94": {
        "easting": 576170.838,
        "northing": 6064436.27
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10926097679",
      "osmNodeId": 10926097679,
      "wgs84": {
        "latitude": 54.7099644,
        "longitude": 25.1820531
      },
      "lks94": {
        "easting": 576172.099,
        "northing": 6064371.704
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10926097680",
      "osmNodeId": 10926097680,
      "wgs84": {
        "latitude": 54.7103649,
        "longitude": 25.1823664
      },
      "lks94": {
        "easting": 576191.537,
        "northing": 6064416.615
      }
    },
    {
      "id": "osm:node:10926097681",
      "osmNodeId": 10926097681,
      "wgs84": {
        "latitude": 54.7101632,
        "longitude": 25.1817498
      },
      "lks94": {
        "easting": 576152.183,
        "northing": 6064393.499
      }
    },
    {
      "id": "osm:node:10968741082",
      "osmNodeId": 10968741082,
      "wgs84": {
        "latitude": 54.6539267,
        "longitude": 25.3027796
      },
      "lks94": {
        "easting": 584067.072,
        "northing": 6058273.21
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10968741083",
      "osmNodeId": 10968741083,
      "wgs84": {
        "latitude": 54.6542618,
        "longitude": 25.3023162
      },
      "lks94": {
        "easting": 584036.48,
        "northing": 6058309.947
      }
    },
    {
      "id": "osm:node:10968741084",
      "osmNodeId": 10968741084,
      "wgs84": {
        "latitude": 54.6543467,
        "longitude": 25.3035553
      },
      "lks94": {
        "easting": 584116.257,
        "northing": 6058320.879
      }
    },
    {
      "id": "osm:node:10969600463",
      "osmNodeId": 10969600463,
      "wgs84": {
        "latitude": 54.6991202,
        "longitude": 25.221849
      },
      "lks94": {
        "easting": 578757.449,
        "northing": 6063208.797
      }
    },
    {
      "id": "osm:node:10969600464",
      "osmNodeId": 10969600464,
      "wgs84": {
        "latitude": 54.6997038,
        "longitude": 25.2222779
      },
      "lks94": {
        "easting": 578783.962,
        "northing": 6063274.225
      }
    },
    {
      "id": "osm:node:10969600465",
      "osmNodeId": 10969600465,
      "wgs84": {
        "latitude": 54.6990109,
        "longitude": 25.2223088
      },
      "lks94": {
        "easting": 578787.297,
        "northing": 6063197.149
      }
    },
    {
      "id": "osm:node:10969600466",
      "osmNodeId": 10969600466,
      "wgs84": {
        "latitude": 54.6997954,
        "longitude": 25.2232629
      },
      "lks94": {
        "easting": 578847.271,
        "northing": 6063285.525
      }
    },
    {
      "id": "osm:node:10969600467",
      "osmNodeId": 10969600467,
      "wgs84": {
        "latitude": 54.6996915,
        "longitude": 25.2231838
      },
      "lks94": {
        "easting": 578842.375,
        "northing": 6063273.874
      }
    },
    {
      "id": "osm:node:10969600468",
      "osmNodeId": 10969600468,
      "wgs84": {
        "latitude": 54.6998704,
        "longitude": 25.2221481
      },
      "lks94": {
        "easting": 578775.274,
        "northing": 6063292.62
      }
    },
    {
      "id": "osm:node:10969600469",
      "osmNodeId": 10969600469,
      "wgs84": {
        "latitude": 54.6990303,
        "longitude": 25.2212098
      },
      "lks94": {
        "easting": 578716.424,
        "northing": 6063198.075
      }
    },
    {
      "id": "osm:node:10969600470",
      "osmNodeId": 10969600470,
      "wgs84": {
        "latitude": 54.6995865,
        "longitude": 25.2229232
      },
      "lks94": {
        "easting": 578825.782,
        "northing": 6063261.896
      }
    },
    {
      "id": "osm:node:10969600471",
      "osmNodeId": 10969600471,
      "wgs84": {
        "latitude": 54.698877,
        "longitude": 25.2224176
      },
      "lks94": {
        "easting": 578794.569,
        "northing": 6063182.37
      }
    },
    {
      "id": "osm:node:10969600472",
      "osmNodeId": 10969600472,
      "wgs84": {
        "latitude": 54.6988734,
        "longitude": 25.222591
      },
      "lks94": {
        "easting": 578805.752,
        "northing": 6063182.164
      }
    },
    {
      "id": "osm:node:10969674117",
      "osmNodeId": 10969674117,
      "wgs84": {
        "latitude": 54.7072782,
        "longitude": 25.2260215
      },
      "lks94": {
        "easting": 579010.526,
        "northing": 6064121.368
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:10969674118",
      "osmNodeId": 10969674118,
      "wgs84": {
        "latitude": 54.7072435,
        "longitude": 25.2271623
      },
      "lks94": {
        "easting": 579084.109,
        "northing": 6064118.791
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:10969674119",
      "osmNodeId": 10969674119,
      "wgs84": {
        "latitude": 54.7070423,
        "longitude": 25.2267833
      },
      "lks94": {
        "easting": 579060.077,
        "northing": 6064095.973
      }
    },
    {
      "id": "osm:node:10969674120",
      "osmNodeId": 10969674120,
      "wgs84": {
        "latitude": 54.707497,
        "longitude": 25.2263976
      },
      "lks94": {
        "easting": 579034.337,
        "northing": 6064146.141
      }
    },
    {
      "id": "osm:node:10969674121",
      "osmNodeId": 10969674121,
      "wgs84": {
        "latitude": 54.7034043,
        "longitude": 25.2239654
      },
      "lks94": {
        "easting": 578885.546,
        "northing": 6063687.939
      }
    },
    {
      "id": "osm:node:10969674122",
      "osmNodeId": 10969674122,
      "wgs84": {
        "latitude": 54.703708,
        "longitude": 25.2246845
      },
      "lks94": {
        "easting": 578931.301,
        "northing": 6063722.546
      }
    },
    {
      "id": "osm:node:11011852100",
      "osmNodeId": 11011852100,
      "wgs84": {
        "latitude": 54.6941713,
        "longitude": 25.2158482
      },
      "lks94": {
        "easting": 578380.21,
        "northing": 6062651.331
      }
    },
    {
      "id": "osm:node:11230979787",
      "osmNodeId": 11230979787,
      "wgs84": {
        "latitude": 54.7239297,
        "longitude": 25.3349675
      },
      "lks94": {
        "easting": 585995.858,
        "northing": 6066102.533
      }
    },
    {
      "id": "osm:node:11230979788",
      "osmNodeId": 11230979788,
      "wgs84": {
        "latitude": 54.7268669,
        "longitude": 25.3260487
      },
      "lks94": {
        "easting": 585415.185,
        "northing": 6066418.51
      }
    },
    {
      "id": "osm:node:11230979819",
      "osmNodeId": 11230979819,
      "wgs84": {
        "latitude": 54.7246419,
        "longitude": 25.3317341
      },
      "lks94": {
        "easting": 585786.078,
        "northing": 6066177.834
      }
    },
    {
      "id": "osm:node:11230979827",
      "osmNodeId": 11230979827,
      "wgs84": {
        "latitude": 54.7239448,
        "longitude": 25.3348018
      },
      "lks94": {
        "easting": 585985.153,
        "northing": 6066104.011
      }
    },
    {
      "id": "osm:node:11230979832",
      "osmNodeId": 11230979832,
      "wgs84": {
        "latitude": 54.7238495,
        "longitude": 25.3383763
      },
      "lks94": {
        "easting": 586215.603,
        "northing": 6066097.791
      }
    },
    {
      "id": "osm:node:11655624820",
      "osmNodeId": 11655624820,
      "wgs84": {
        "latitude": 54.6707287,
        "longitude": 25.26332
      },
      "lks94": {
        "easting": 581487.284,
        "northing": 6060096.524
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11655624821",
      "osmNodeId": 11655624821,
      "wgs84": {
        "latitude": 54.6707516,
        "longitude": 25.2634437
      },
      "lks94": {
        "easting": 581495.217,
        "northing": 6060099.216
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11655792798",
      "osmNodeId": 11655792798,
      "wgs84": {
        "latitude": 54.6727896,
        "longitude": 25.2460086
      },
      "lks94": {
        "easting": 580366.645,
        "northing": 6060305.923
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11655792799",
      "osmNodeId": 11655792799,
      "wgs84": {
        "latitude": 54.6726995,
        "longitude": 25.2458333
      },
      "lks94": {
        "easting": 580355.516,
        "northing": 6060295.696
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11655792800",
      "osmNodeId": 11655792800,
      "wgs84": {
        "latitude": 54.6703724,
        "longitude": 25.2413193
      },
      "lks94": {
        "easting": 580068.959,
        "northing": 6060031.565
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11655792801",
      "osmNodeId": 11655792801,
      "wgs84": {
        "latitude": 54.6703003,
        "longitude": 25.2411803
      },
      "lks94": {
        "easting": 580060.136,
        "northing": 6060023.382
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11658304729",
      "osmNodeId": 11658304729,
      "wgs84": {
        "latitude": 54.6792284,
        "longitude": 25.255429
      },
      "lks94": {
        "easting": 580961.409,
        "northing": 6061033.297
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11658304730",
      "osmNodeId": 11658304730,
      "wgs84": {
        "latitude": 54.679176,
        "longitude": 25.2552736
      },
      "lks94": {
        "easting": 580951.493,
        "northing": 6061027.286
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11736801374",
      "osmNodeId": 11736801374,
      "wgs84": {
        "latitude": 54.6539257,
        "longitude": 25.3029851
      },
      "lks94": {
        "easting": 584080.334,
        "northing": 6058273.345
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11755506732",
      "osmNodeId": 11755506732,
      "wgs84": {
        "latitude": 54.7234135,
        "longitude": 25.2539429
      },
      "lks94": {
        "easting": 580777.733,
        "northing": 6065948.808
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11755506733",
      "osmNodeId": 11755506733,
      "wgs84": {
        "latitude": 54.7235499,
        "longitude": 25.253894
      },
      "lks94": {
        "easting": 580774.312,
        "northing": 6065963.931
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11794951145",
      "osmNodeId": 11794951145,
      "wgs84": {
        "latitude": 54.7039742,
        "longitude": 25.283878
      },
      "lks94": {
        "easting": 582745.592,
        "northing": 6063820.341
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11794951146",
      "osmNodeId": 11794951146,
      "wgs84": {
        "latitude": 54.7037926,
        "longitude": 25.2834175
      },
      "lks94": {
        "easting": 582716.284,
        "northing": 6063799.589
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11794951147",
      "osmNodeId": 11794951147,
      "wgs84": {
        "latitude": 54.7037667,
        "longitude": 25.2842388
      },
      "lks94": {
        "easting": 582769.267,
        "northing": 6063797.675
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11794951148",
      "osmNodeId": 11794951148,
      "wgs84": {
        "latitude": 54.7035904,
        "longitude": 25.2837915
      },
      "lks94": {
        "easting": 582740.798,
        "northing": 6063777.528
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11794951149",
      "osmNodeId": 11794951149,
      "wgs84": {
        "latitude": 54.703751,
        "longitude": 25.28482
      },
      "lks94": {
        "easting": 582806.755,
        "northing": 6063796.613
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11830115289",
      "osmNodeId": 11830115289,
      "wgs84": {
        "latitude": 54.7523333,
        "longitude": 25.2800346
      },
      "lks94": {
        "easting": 582399.723,
        "northing": 6069197.557
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11830115290",
      "osmNodeId": 11830115290,
      "wgs84": {
        "latitude": 54.7525756,
        "longitude": 25.2800813
      },
      "lks94": {
        "easting": 582402.237,
        "northing": 6069224.577
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11830115309",
      "osmNodeId": 11830115309,
      "wgs84": {
        "latitude": 54.7697311,
        "longitude": 25.2716757
      },
      "lks94": {
        "easting": 581826.56,
        "northing": 6071123.932
      }
    },
    {
      "id": "osm:node:11830115310",
      "osmNodeId": 11830115310,
      "wgs84": {
        "latitude": 54.7698757,
        "longitude": 25.271545
      },
      "lks94": {
        "easting": 581817.859,
        "northing": 6071139.872
      }
    },
    {
      "id": "osm:node:11830115318",
      "osmNodeId": 11830115318,
      "wgs84": {
        "latitude": 54.7649012,
        "longitude": 25.2712893
      },
      "lks94": {
        "easting": 581811.442,
        "northing": 6070585.973
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11830115319",
      "osmNodeId": 11830115319,
      "wgs84": {
        "latitude": 54.7650752,
        "longitude": 25.2716529
      },
      "lks94": {
        "easting": 581834.488,
        "northing": 6070605.761
      }
    },
    {
      "id": "osm:node:11830115320",
      "osmNodeId": 11830115320,
      "wgs84": {
        "latitude": 54.7646063,
        "longitude": 25.2717859
      },
      "lks94": {
        "easting": 581843.993,
        "northing": 6070553.733
      }
    },
    {
      "id": "osm:node:11836937605",
      "osmNodeId": 11836937605,
      "wgs84": {
        "latitude": 54.6888205,
        "longitude": 25.2563425
      },
      "lks94": {
        "easting": 581001.215,
        "northing": 6062101.823
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:11836937606",
      "osmNodeId": 11836937606,
      "wgs84": {
        "latitude": 54.6889663,
        "longitude": 25.2561104
      },
      "lks94": {
        "easting": 580985.961,
        "northing": 6062117.781
      }
    },
    {
      "id": "osm:node:11836937607",
      "osmNodeId": 11836937607,
      "wgs84": {
        "latitude": 54.6890935,
        "longitude": 25.2567048
      },
      "lks94": {
        "easting": 581024.028,
        "northing": 6062132.622
      }
    },
    {
      "id": "osm:node:11836937608",
      "osmNodeId": 11836937608,
      "wgs84": {
        "latitude": 54.6892471,
        "longitude": 25.2564339
      },
      "lks94": {
        "easting": 581006.258,
        "northing": 6062149.403
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:11981641253",
      "osmNodeId": 11981641253,
      "wgs84": {
        "latitude": 54.7616606,
        "longitude": 25.3733374
      },
      "lks94": {
        "easting": 588385.214,
        "northing": 6070349.146
      }
    },
    {
      "id": "osm:node:11981641262",
      "osmNodeId": 11981641262,
      "wgs84": {
        "latitude": 54.7617545,
        "longitude": 25.3730534
      },
      "lks94": {
        "easting": 588366.733,
        "northing": 6070359.238
      }
    },
    {
      "id": "osm:node:12029120558",
      "osmNodeId": 12029120558,
      "wgs84": {
        "latitude": 54.7240315,
        "longitude": 25.2814846
      },
      "lks94": {
        "easting": 582550.588,
        "northing": 6066049.634
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:12029120559",
      "osmNodeId": 12029120559,
      "wgs84": {
        "latitude": 54.7242306,
        "longitude": 25.2813119
      },
      "lks94": {
        "easting": 582539.059,
        "northing": 6066071.588
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:12084554715",
      "osmNodeId": 12084554715,
      "wgs84": {
        "latitude": 54.7036029,
        "longitude": 25.2186315
      },
      "lks94": {
        "easting": 578541.406,
        "northing": 6063704.06
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:12084554716",
      "osmNodeId": 12084554716,
      "wgs84": {
        "latitude": 54.7038805,
        "longitude": 25.2185574
      },
      "lks94": {
        "easting": 578536.094,
        "northing": 6063734.87
      }
    },
    {
      "id": "osm:node:12084554719",
      "osmNodeId": 12084554719,
      "wgs84": {
        "latitude": 54.7038545,
        "longitude": 25.2191377
      },
      "lks94": {
        "easting": 578573.543,
        "northing": 6063732.626
      }
    },
    {
      "id": "osm:node:12084554740",
      "osmNodeId": 12084554740,
      "wgs84": {
        "latitude": 54.7059541,
        "longitude": 25.2152978
      },
      "lks94": {
        "easting": 578322.027,
        "northing": 6063961.994
      }
    },
    {
      "id": "osm:node:12084554741",
      "osmNodeId": 12084554741,
      "wgs84": {
        "latitude": 54.706251,
        "longitude": 25.2159478
      },
      "lks94": {
        "easting": 578363.343,
        "northing": 6063995.761
      }
    },
    {
      "id": "osm:node:12084554742",
      "osmNodeId": 12084554742,
      "wgs84": {
        "latitude": 54.7063861,
        "longitude": 25.2154595
      },
      "lks94": {
        "easting": 578331.615,
        "northing": 6064010.251
      }
    },
    {
      "id": "osm:node:12084554744",
      "osmNodeId": 12084554744,
      "wgs84": {
        "latitude": 54.705863,
        "longitude": 25.2158955
      },
      "lks94": {
        "easting": 578360.721,
        "northing": 6063952.523
      }
    },
    {
      "id": "osm:node:12120348844",
      "osmNodeId": 12120348844,
      "wgs84": {
        "latitude": 54.735485,
        "longitude": 25.2166642
      },
      "lks94": {
        "easting": 578353.104,
        "northing": 6067249.948
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:12120348845",
      "osmNodeId": 12120348845,
      "wgs84": {
        "latitude": 54.7356638,
        "longitude": 25.2162409
      },
      "lks94": {
        "easting": 578325.5,
        "northing": 6067269.373
      }
    },
    {
      "id": "osm:node:12120348846",
      "osmNodeId": 12120348846,
      "wgs84": {
        "latitude": 54.7359486,
        "longitude": 25.2167851
      },
      "lks94": {
        "easting": 578359.995,
        "northing": 6067301.676
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:12120348847",
      "osmNodeId": 12120348847,
      "wgs84": {
        "latitude": 54.7357558,
        "longitude": 25.2171368
      },
      "lks94": {
        "easting": 578383.015,
        "northing": 6067280.612
      }
    },
    {
      "id": "osm:node:12120765776",
      "osmNodeId": 12120765776,
      "wgs84": {
        "latitude": 54.7424197,
        "longitude": 25.2236943
      },
      "lks94": {
        "easting": 578792.359,
        "northing": 6068029.57
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:12120765777",
      "osmNodeId": 12120765777,
      "wgs84": {
        "latitude": 54.7421445,
        "longitude": 25.2228765
      },
      "lks94": {
        "easting": 578740.238,
        "northing": 6067998.025
      },
      "direction": "forward"
    },
    {
      "id": "osm:node:12120765778",
      "osmNodeId": 12120765778,
      "wgs84": {
        "latitude": 54.7425104,
        "longitude": 25.2229062
      },
      "lks94": {
        "easting": 578741.441,
        "northing": 6068038.779
      }
    },
    {
      "id": "osm:node:12120765779",
      "osmNodeId": 12120765779,
      "wgs84": {
        "latitude": 54.742099,
        "longitude": 25.2236519
      },
      "lks94": {
        "easting": 578790.252,
        "northing": 6067993.832
      }
    },
    {
      "id": "osm:node:12164899840",
      "osmNodeId": 12164899840,
      "wgs84": {
        "latitude": 54.6528752,
        "longitude": 25.2827079
      },
      "lks94": {
        "easting": 582774.075,
        "northing": 6058132.354
      }
    },
    {
      "id": "osm:node:12164899841",
      "osmNodeId": 12164899841,
      "wgs84": {
        "latitude": 54.6527976,
        "longitude": 25.2826918
      },
      "lks94": {
        "easting": 582773.193,
        "northing": 6058123.699
      }
    },
    {
      "id": "osm:node:12579135528",
      "osmNodeId": 12579135528,
      "wgs84": {
        "latitude": 54.6636501,
        "longitude": 25.2363775
      },
      "lks94": {
        "easting": 579763.386,
        "northing": 6059277.84
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:12579135529",
      "osmNodeId": 12579135529,
      "wgs84": {
        "latitude": 54.6638897,
        "longitude": 25.2359642
      },
      "lks94": {
        "easting": 579736.255,
        "northing": 6059304.034
      }
    },
    {
      "id": "osm:node:12579135530",
      "osmNodeId": 12579135530,
      "wgs84": {
        "latitude": 54.6634849,
        "longitude": 25.235886
      },
      "lks94": {
        "easting": 579732.003,
        "northing": 6059258.897
      }
    },
    {
      "id": "osm:node:12579135531",
      "osmNodeId": 12579135531,
      "wgs84": {
        "latitude": 54.6593572,
        "longitude": 25.2327138
      },
      "lks94": {
        "easting": 579535.425,
        "northing": 6058795.943
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:12579135532",
      "osmNodeId": 12579135532,
      "wgs84": {
        "latitude": 54.6593904,
        "longitude": 25.2330274
      },
      "lks94": {
        "easting": 579555.593,
        "northing": 6058799.993
      }
    },
    {
      "id": "osm:node:12579135533",
      "osmNodeId": 12579135533,
      "wgs84": {
        "latitude": 54.658922,
        "longitude": 25.2327734
      },
      "lks94": {
        "easting": 579540.12,
        "northing": 6058747.578
      }
    },
    {
      "id": "osm:node:12579135534",
      "osmNodeId": 12579135534,
      "wgs84": {
        "latitude": 54.6589241,
        "longitude": 25.2330957
      },
      "lks94": {
        "easting": 579560.91,
        "northing": 6058748.177
      },
      "direction": "backward"
    },
    {
      "id": "osm:node:12579135535",
      "osmNodeId": 12579135535,
      "wgs84": {
        "latitude": 54.6498107,
        "longitude": 25.2166338
      },
      "lks94": {
        "easting": 578516.39,
        "northing": 6057715.454
      }
    },
    {
      "id": "osm:node:12579135536",
      "osmNodeId": 12579135536,
      "wgs84": {
        "latitude": 54.6500332,
        "longitude": 25.2165993
      },
      "lks94": {
        "easting": 578513.734,
        "northing": 6057740.176
      }
    },
    {
      "id": "osm:node:12579135539",
      "osmNodeId": 12579135539,
      "wgs84": {
        "latitude": 54.6541695,
        "longitude": 25.2247618
      },
      "lks94": {
        "easting": 579032.451,
        "northing": 6058209.645
      }
    },
    {
      "id": "osm:node:12579135540",
      "osmNodeId": 12579135540,
      "wgs84": {
        "latitude": 54.6545101,
        "longitude": 25.2245642
      },
      "lks94": {
        "easting": 579019.04,
        "northing": 6058247.327
      }
    },
    {
      "id": "osm:node:12579135541",
      "osmNodeId": 12579135541,
      "wgs84": {
        "latitude": 54.6540606,
        "longitude": 25.2241786
      },
      "lks94": {
        "easting": 578995.031,
        "northing": 6058196.87
      }
    },
    {
      "id": "osm:node:12861342434",
      "osmNodeId": 12861342434,
      "wgs84": {
        "latitude": 54.6783697,
        "longitude": 25.3109733
      },
      "lks94": {
        "easting": 584544.99,
        "northing": 6061003.199
      }
    },
    {
      "id": "osm:node:12861342435",
      "osmNodeId": 12861342435,
      "wgs84": {
        "latitude": 54.6788948,
        "longitude": 25.311347
      },
      "lks94": {
        "easting": 584567.997,
        "northing": 6061062.085
      }
    },
    {
      "id": "osm:node:13274577486",
      "osmNodeId": 13274577486,
      "wgs84": {
        "latitude": 54.6767653,
        "longitude": 25.3075422
      },
      "lks94": {
        "easting": 584327.055,
        "northing": 6060820.526
      }
    },
    {
      "id": "osm:node:13274577487",
      "osmNodeId": 13274577487,
      "wgs84": {
        "latitude": 54.6768061,
        "longitude": 25.3066649
      },
      "lks94": {
        "easting": 584270.394,
        "northing": 6060824.014
      }
    },
    {
      "id": "osm:node:13455807749",
      "osmNodeId": 13455807749,
      "wgs84": {
        "latitude": 54.7975963,
        "longitude": 25.3953797
      },
      "lks94": {
        "easting": 589724.137,
        "northing": 6074376.291
      }
    },
    {
      "id": "osm:node:13455807750",
      "osmNodeId": 13455807750,
      "wgs84": {
        "latitude": 54.8012301,
        "longitude": 25.4034345
      },
      "lks94": {
        "easting": 590233.937,
        "northing": 6074791.022
      }
    },
    {
      "id": "osm:node:13811024387",
      "osmNodeId": 13811024387,
      "wgs84": {
        "latitude": 54.6591991,
        "longitude": 25.1595671
      },
      "lks94": {
        "easting": 574816.467,
        "northing": 6058697.969
      },
      "direction": "forward"
    }
  ]
}

